
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return import.meta.resolve($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireada9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireada9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bZWYA", function(module, exports) {

$parcel$export(module.exports, "create", () => $8bc323a7705bd15f$export$185802fd694ee1f5);
$parcel$export(module.exports, "addSheet", () => $8bc323a7705bd15f$export$f6e9a5c4a1110840);
/**
 * @license sheetly
 * Copyright (C) 2023  DarrenDanielDay <Darren_Daniel_Day@hotmail.com>
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * Create a CSSStyleSheet.
 * @param code the css code
 * @param baseURL optional base url if you want to use `url()` in it
 * @returns a created style sheet
 */ const $8bc323a7705bd15f$export$185802fd694ee1f5 = (code, baseURL)=>{
    const sheet = new CSSStyleSheet({
        baseURL: baseURL
    });
    sheet.replaceSync(code);
    return sheet;
};
const $8bc323a7705bd15f$export$f6e9a5c4a1110840 = (sheet, doc = document)=>{
    doc.adoptedStyleSheets = doc.adoptedStyleSheets.concat(sheet);
};
const $8bc323a7705bd15f$export$dbf350e5966cf602 = (templates, ...substitutions)=>$8bc323a7705bd15f$export$185802fd694ee1f5(String.raw(templates, ...substitutions));

});

parcelRegister("l72Zw", function(module, exports) {

$parcel$export(module.exports, "bootstrapLocal", () => $f5ec9271d2687ff6$export$9222e7b37f63b62d);
$parcel$export(module.exports, "title", () => (parcelRequire("iTeYD")).sheet);
$parcel$export(module.exports, "theme", () => (parcelRequire("jW2zV")).sheet);
$parcel$export(module.exports, "bootstrap", () => (parcelRequire("kOWJ5")).sheet);
$parcel$export(module.exports, "table", () => (parcelRequire("jl8dB")).sheet);
$parcel$export(module.exports, "viewTransition", () => (parcelRequire("hB6dd")).sheet);

var $bZWYA = parcelRequire("bZWYA");

var $kOWJ5 = parcelRequire("kOWJ5");

var $iTeYD = parcelRequire("iTeYD");

var $jW2zV = parcelRequire("jW2zV");

var $jl8dB = parcelRequire("jl8dB");

var $hB6dd = parcelRequire("hB6dd");
const $f5ec9271d2687ff6$export$9222e7b37f63b62d = (0, $bZWYA.create)((0, $kOWJ5.text).replaceAll(":root", ":host"), "");

});
parcelRegister("kOWJ5", function(module, exports) {

$parcel$export(module.exports, "text", () => $f28607f65f09ab1c$export$6f093cfa640b7166);
$parcel$export(module.exports, "sheet", () => $f28607f65f09ab1c$export$995990c5c04c46f0);

var $bZWYA = parcelRequire("bZWYA");
let $f28607f65f09ab1c$export$6f093cfa640b7166 = "@charset \"UTF-8\";/*!\r\n * Bootstrap  v5.3.0-alpha3 (https://getbootstrap.com/)\r\n * Copyright 2011-2023 The Bootstrap Authors\r\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\r\n */:root,[data-bs-theme=light]{--bs-blue:#0d6efd;--bs-indigo:#6610f2;--bs-purple:#6f42c1;--bs-pink:#d63384;--bs-red:#dc3545;--bs-orange:#fd7e14;--bs-yellow:#ffc107;--bs-green:#198754;--bs-teal:#20c997;--bs-cyan:#0dcaf0;--bs-black:#000;--bs-white:#fff;--bs-gray:#6c757d;--bs-gray-dark:#343a40;--bs-gray-100:#f8f9fa;--bs-gray-200:#e9ecef;--bs-gray-300:#dee2e6;--bs-gray-400:#ced4da;--bs-gray-500:#adb5bd;--bs-gray-600:#6c757d;--bs-gray-700:#495057;--bs-gray-800:#343a40;--bs-gray-900:#212529;--bs-primary:#0d6efd;--bs-secondary:#6c757d;--bs-success:#198754;--bs-info:#0dcaf0;--bs-warning:#ffc107;--bs-danger:#dc3545;--bs-light:#f8f9fa;--bs-dark:#212529;--bs-primary-rgb:13,110,253;--bs-secondary-rgb:108,117,125;--bs-success-rgb:25,135,84;--bs-info-rgb:13,202,240;--bs-warning-rgb:255,193,7;--bs-danger-rgb:220,53,69;--bs-light-rgb:248,249,250;--bs-dark-rgb:33,37,41;--bs-primary-text-emphasis:#052c65;--bs-secondary-text-emphasis:#2b2f32;--bs-success-text-emphasis:#0a3622;--bs-info-text-emphasis:#055160;--bs-warning-text-emphasis:#664d03;--bs-danger-text-emphasis:#58151c;--bs-light-text-emphasis:#495057;--bs-dark-text-emphasis:#495057;--bs-primary-bg-subtle:#cfe2ff;--bs-secondary-bg-subtle:#e2e3e5;--bs-success-bg-subtle:#d1e7dd;--bs-info-bg-subtle:#cff4fc;--bs-warning-bg-subtle:#fff3cd;--bs-danger-bg-subtle:#f8d7da;--bs-light-bg-subtle:#fcfcfd;--bs-dark-bg-subtle:#ced4da;--bs-primary-border-subtle:#9ec5fe;--bs-secondary-border-subtle:#c4c8cb;--bs-success-border-subtle:#a3cfbb;--bs-info-border-subtle:#9eeaf9;--bs-warning-border-subtle:#ffe69c;--bs-danger-border-subtle:#f1aeb5;--bs-light-border-subtle:#e9ecef;--bs-dark-border-subtle:#adb5bd;--bs-white-rgb:255,255,255;--bs-black-rgb:0,0,0;--bs-font-sans-serif:system-ui,-apple-system,\"Segoe UI\",Roboto,\"Helvetica Neue\",\"Noto Sans\",\"Liberation Sans\",Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--bs-font-monospace:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--bs-gradient:linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));--bs-body-font-family:var(--bs-font-sans-serif);--bs-body-font-size:1rem;--bs-body-font-weight:400;--bs-body-line-height:1.5;--bs-body-color:#212529;--bs-body-color-rgb:33,37,41;--bs-body-bg:#fff;--bs-body-bg-rgb:255,255,255;--bs-emphasis-color:#000;--bs-emphasis-color-rgb:0,0,0;--bs-secondary-color:rgba(33, 37, 41, 0.75);--bs-secondary-color-rgb:33,37,41;--bs-secondary-bg:#e9ecef;--bs-secondary-bg-rgb:233,236,239;--bs-tertiary-color:rgba(33, 37, 41, 0.5);--bs-tertiary-color-rgb:33,37,41;--bs-tertiary-bg:#f8f9fa;--bs-tertiary-bg-rgb:248,249,250;--bs-link-color:#0d6efd;--bs-link-color-rgb:13,110,253;--bs-link-decoration:underline;--bs-link-hover-color:#0a58ca;--bs-link-hover-color-rgb:10,88,202;--bs-code-color:#d63384;--bs-highlight-bg:#fff3cd;--bs-border-width:1px;--bs-border-style:solid;--bs-border-color:#dee2e6;--bs-border-color-translucent:rgba(0, 0, 0, 0.175);--bs-border-radius:0.375rem;--bs-border-radius-sm:0.25rem;--bs-border-radius-lg:0.5rem;--bs-border-radius-xl:1rem;--bs-border-radius-xxl:2rem;--bs-border-radius-2xl:var(--bs-border-radius-xxl);--bs-border-radius-pill:50rem;--bs-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15);--bs-box-shadow-sm:0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);--bs-box-shadow-lg:0 1rem 3rem rgba(0, 0, 0, 0.175);--bs-box-shadow-inset:inset 0 1px 2px rgba(0, 0, 0, 0.075);--bs-focus-ring-width:0.25rem;--bs-focus-ring-opacity:0.25;--bs-focus-ring-color:rgba(13, 110, 253, 0.25);--bs-form-valid-color:#198754;--bs-form-valid-border-color:#198754;--bs-form-invalid-color:#dc3545;--bs-form-invalid-border-color:#dc3545}[data-bs-theme=dark]{color-scheme:dark;--bs-body-color:#adb5bd;--bs-body-color-rgb:173,181,189;--bs-body-bg:#212529;--bs-body-bg-rgb:33,37,41;--bs-emphasis-color:#fff;--bs-emphasis-color-rgb:255,255,255;--bs-secondary-color:rgba(173, 181, 189, 0.75);--bs-secondary-color-rgb:173,181,189;--bs-secondary-bg:#343a40;--bs-secondary-bg-rgb:52,58,64;--bs-tertiary-color:rgba(173, 181, 189, 0.5);--bs-tertiary-color-rgb:173,181,189;--bs-tertiary-bg:#2b3035;--bs-tertiary-bg-rgb:43,48,53;--bs-primary-text-emphasis:#6ea8fe;--bs-secondary-text-emphasis:#a7acb1;--bs-success-text-emphasis:#75b798;--bs-info-text-emphasis:#6edff6;--bs-warning-text-emphasis:#ffda6a;--bs-danger-text-emphasis:#ea868f;--bs-light-text-emphasis:#f8f9fa;--bs-dark-text-emphasis:#dee2e6;--bs-primary-bg-subtle:#031633;--bs-secondary-bg-subtle:#161719;--bs-success-bg-subtle:#051b11;--bs-info-bg-subtle:#032830;--bs-warning-bg-subtle:#332701;--bs-danger-bg-subtle:#2c0b0e;--bs-light-bg-subtle:#343a40;--bs-dark-bg-subtle:#1a1d20;--bs-primary-border-subtle:#084298;--bs-secondary-border-subtle:#41464b;--bs-success-border-subtle:#0f5132;--bs-info-border-subtle:#087990;--bs-warning-border-subtle:#997404;--bs-danger-border-subtle:#842029;--bs-light-border-subtle:#495057;--bs-dark-border-subtle:#343a40;--bs-link-color:#6ea8fe;--bs-link-hover-color:#8bb9fe;--bs-link-color-rgb:110,168,254;--bs-link-hover-color-rgb:139,185,254;--bs-code-color:#e685b5;--bs-border-color:#495057;--bs-border-color-translucent:rgba(255, 255, 255, 0.15);--bs-form-valid-color:#75b798;--bs-form-valid-border-color:#75b798;--bs-form-invalid-color:#ea868f;--bs-form-invalid-border-color:#ea868f}*,::after,::before{box-sizing:border-box}@media (prefers-reduced-motion:no-preference){:root{scroll-behavior:smooth}}body{margin:0;font-family:var(--bs-body-font-family);font-size:var(--bs-body-font-size);font-weight:var(--bs-body-font-weight);line-height:var(--bs-body-line-height);color:var(--bs-body-color);text-align:var(--bs-body-text-align);background-color:var(--bs-body-bg);-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:transparent}hr{margin:1rem 0;color:inherit;border:0;border-top:var(--bs-border-width) solid;opacity:.25}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem;font-weight:500;line-height:1.2;color:var(--bs-heading-color,inherit)}.h1,h1{font-size:calc(1.375rem + 1.5vw)}@media (min-width:1200px){.h1,h1{font-size:2.5rem}}.h2,h2{font-size:calc(1.325rem + .9vw)}@media (min-width:1200px){.h2,h2{font-size:2rem}}.h3,h3{font-size:calc(1.3rem + .6vw)}@media (min-width:1200px){.h3,h3{font-size:1.75rem}}.h4,h4{font-size:calc(1.275rem + .3vw)}@media (min-width:1200px){.h4,h4{font-size:1.5rem}}.h5,h5{font-size:1.25rem}.h6,h6{font-size:1rem}p{margin-top:0;margin-bottom:1rem}abbr[title]{-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;-webkit-text-decoration-skip-ink:none;text-decoration-skip-ink:none}address{margin-bottom:1rem;font-style:normal;line-height:inherit}ol,ul{padding-left:2rem}dl,ol,ul{margin-top:0;margin-bottom:1rem}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}b,strong{font-weight:bolder}.small,small{font-size:.875em}.mark,mark{padding:.1875em;background-color:var(--bs-highlight-bg)}sub,sup{position:relative;font-size:.75em;line-height:0;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}a{color:rgba(var(--bs-link-color-rgb),var(--bs-link-opacity,1));text-decoration:underline}a:hover{--bs-link-color-rgb:var(--bs-link-hover-color-rgb)}a:not([href]):not([class]),a:not([href]):not([class]):hover{color:inherit;text-decoration:none}code,kbd,pre,samp{font-family:var(--bs-font-monospace);font-size:1em}pre{display:block;margin-top:0;margin-bottom:1rem;overflow:auto;font-size:.875em}pre code{font-size:inherit;color:inherit;word-break:normal}code{font-size:.875em;color:var(--bs-code-color);word-wrap:break-word}a>code{color:inherit}kbd{padding:.1875rem .375rem;font-size:.875em;color:var(--bs-body-bg);background-color:var(--bs-body-color);border-radius:.25rem}kbd kbd{padding:0;font-size:1em}figure{margin:0 0 1rem}img,svg{vertical-align:middle}table{caption-side:bottom;border-collapse:collapse}caption{padding-top:.5rem;padding-bottom:.5rem;color:var(--bs-secondary-color);text-align:left}th{text-align:inherit;text-align:-webkit-match-parent}tbody,td,tfoot,th,thead,tr{border-color:inherit;border-style:solid;border-width:0}label{display:inline-block}button{border-radius:0}button:focus:not(:focus-visible){outline:0}button,input,optgroup,select,textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}button,select{text-transform:none}[role=button]{cursor:pointer}select{word-wrap:normal}select:disabled{opacity:1}[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not(\r[type=time]\r)::-webkit-calendar-picker-indicator{display:none!important}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}[type=button]:not(:disabled),[type=reset]:not(:disabled),[type=submit]:not(:disabled),button:not(:disabled){cursor:pointer}::-moz-focus-inner{padding:0;border-style:none}textarea{resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{float:left;width:100%;padding:0;margin-bottom:.5rem;font-size:calc(1.275rem + .3vw);line-height:inherit}@media (min-width:1200px){legend{font-size:1.5rem}}legend+*{clear:left}::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-fields-wrapper,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-text,::-webkit-datetime-edit-year-field{padding:0}::-webkit-inner-spin-button{height:auto}[type=search]{outline-offset:-2px;-webkit-appearance:textfield}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-color-swatch-wrapper{padding:0}::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}::file-selector-button{font:inherit;-webkit-appearance:button}output{display:inline-block}iframe{border:0}summary{display:list-item;cursor:pointer}progress{vertical-align:baseline}[hidden]{display:none!important}.lead{font-size:1.25rem;font-weight:300}.blockquote{margin-bottom:1rem;font-size:1.25rem}.blockquote>:last-child{margin-bottom:0}.figure{display:inline-block}.container,.container-fluid{--bs-gutter-x:1.5rem;--bs-gutter-y:0;width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-right:auto;margin-left:auto}@media (min-width:576px){.container{max-width:540px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:960px}}@media (min-width:1200px){.container{max-width:1140px}}@media (min-width:1400px){.container{max-width:1320px}}:root{--bs-breakpoint-xs:0;--bs-breakpoint-sm:576px;--bs-breakpoint-md:768px;--bs-breakpoint-lg:992px;--bs-breakpoint-xl:1200px;--bs-breakpoint-xxl:1400px}.row{--bs-gutter-x:1.5rem;--bs-gutter-y:0;display:flex;flex-wrap:wrap;margin-top:calc(-1 * var(--bs-gutter-y));margin-right:calc(-.5 * var(--bs-gutter-x));margin-left:calc(-.5 * var(--bs-gutter-x))}.row>*{flex-shrink:0;width:100%;max-width:100%;padding-right:calc(var(--bs-gutter-x) * .5);padding-left:calc(var(--bs-gutter-x) * .5);margin-top:var(--bs-gutter-y)}.col{flex:1 0 0%}.col-auto{flex:0 0 auto;width:auto}.col-1{flex:0 0 auto;width:8.33333333%}.col-2{flex:0 0 auto;width:16.66666667%}.col-4{flex:0 0 auto;width:33.33333333%}.col-5{flex:0 0 auto;width:41.66666667%}.col-7{flex:0 0 auto;width:58.33333333%}.col-10{flex:0 0 auto;width:83.33333333%}.table{--bs-table-color:var(--bs-body-color);--bs-table-bg:transparent;--bs-table-border-color:var(--bs-border-color);--bs-table-accent-bg:transparent;--bs-table-striped-color:var(--bs-body-color);--bs-table-striped-bg:rgba(0, 0, 0, 0.05);--bs-table-active-color:var(--bs-body-color);--bs-table-active-bg:rgba(0, 0, 0, 0.1);--bs-table-hover-color:var(--bs-body-color);--bs-table-hover-bg:rgba(0, 0, 0, 0.075);width:100%;margin-bottom:1rem;color:var(--bs-table-color);vertical-align:top;border-color:var(--bs-table-border-color)}.table>:not(caption)>*>*{padding:.5rem .5rem;background-color:var(--bs-table-bg);border-bottom-width:var(--bs-border-width);box-shadow:inset 0 0 0 9999px var(--bs-table-accent-bg)}.table>tbody{vertical-align:inherit}.table>thead{vertical-align:bottom}.form-label{margin-bottom:.5rem}.col-form-label{padding-top:calc(.375rem + var(--bs-border-width));padding-bottom:calc(.375rem + var(--bs-border-width));margin-bottom:0;font-size:inherit;line-height:1.5}.form-text{margin-top:.25rem;font-size:.875em;color:var(--bs-secondary-color)}.form-control{display:block;width:100%;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:var(--bs-body-color);background-color:var(--bs-body-bg);background-clip:padding-box;border:var(--bs-border-width) solid var(--bs-border-color);-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:var(--bs-border-radius);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control{transition:none}}.form-control[type=file]{overflow:hidden}.form-control[type=file]:not(:disabled):not([readonly]){cursor:pointer}.form-control:focus{color:var(--bs-body-color);background-color:var(--bs-body-bg);border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-control::-webkit-date-and-time-value{min-width:85px;height:1.5em;margin:0}.form-control::-webkit-datetime-edit{display:block;padding:0}.form-control::-moz-placeholder{color:var(--bs-secondary-color);opacity:1}.form-control::placeholder{color:var(--bs-secondary-color);opacity:1}.form-control:disabled{background-color:var(--bs-secondary-bg);opacity:1}.form-control::-webkit-file-upload-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:var(--bs-body-color);background-color:var(--bs-tertiary-bg);pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:var(--bs-border-width);border-radius:0;-webkit-transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control::file-selector-button{padding:.375rem .75rem;margin:-.375rem -.75rem;-webkit-margin-end:.75rem;margin-inline-end:.75rem;color:var(--bs-body-color);background-color:var(--bs-tertiary-bg);pointer-events:none;border-color:inherit;border-style:solid;border-width:0;border-inline-end-width:var(--bs-border-width);border-radius:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-control::-webkit-file-upload-button{-webkit-transition:none;transition:none}.form-control::file-selector-button{transition:none}}.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button{background-color:var(--bs-secondary-bg)}.form-control:hover:not(:disabled):not([readonly])::file-selector-button{background-color:var(--bs-secondary-bg)}textarea.form-control{min-height:calc(1.5em + .75rem + calc(var(--bs-border-width) * 2))}.form-select{--bs-form-select-bg-img:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");display:block;width:100%;padding:.375rem 2.25rem .375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:var(--bs-body-color);background-color:var(--bs-body-bg);background-image:var(--bs-form-select-bg-img),var(--bs-form-select-bg-icon,none);background-repeat:no-repeat;background-position:right .75rem center;background-size:16px 12px;border:var(--bs-border-width) solid var(--bs-border-color);border-radius:var(--bs-border-radius);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;-webkit-appearance:none;-moz-appearance:none;appearance:none}@media (prefers-reduced-motion:reduce){.form-select{transition:none}}.form-select:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-select[multiple],.form-select[size]:not([size=\"1\"]){padding-right:.75rem;background-image:none}.form-select:disabled{background-color:var(--bs-secondary-bg)}.form-select:-moz-focusring{color:transparent;text-shadow:0 0 0 var(--bs-body-color)}[data-bs-theme=dark] .form-select{--bs-form-select-bg-img:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23adb5bd' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\")}.form-check{display:block;min-height:1.5rem;padding-left:1.5em;margin-bottom:.125rem}.form-check .form-check-input{float:left;margin-left:-1.5em}.form-check-input{--bs-form-check-bg:var(--bs-body-bg);width:1em;height:1em;margin-top:.25em;vertical-align:top;background-color:var(--bs-form-check-bg);background-image:var(--bs-form-check-bg-image);background-repeat:no-repeat;background-position:center;background-size:contain;border:var(--bs-border-width) solid var(--bs-border-color);-webkit-appearance:none;-moz-appearance:none;appearance:none;-webkit-print-color-adjust:exact;color-adjust:exact;print-color-adjust:exact}.form-check-input[type=checkbox]{border-radius:.25em}.form-check-input[type=radio]{border-radius:50%}.form-check-input:active{filter:brightness(90%)}.form-check-input:focus{border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.form-check-input:checked{background-color:#0d6efd;border-color:#0d6efd}.form-check-input:checked[type=checkbox]{--bs-form-check-bg-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e\")}.form-check-input:checked[type=radio]{--bs-form-check-bg-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\")}.form-check-input[type=checkbox]:indeterminate{background-color:#0d6efd;border-color:#0d6efd;--bs-form-check-bg-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\")}.form-check-input:disabled{pointer-events:none;filter:none;opacity:.5}.form-check-input:disabled~.form-check-label,.form-check-input[disabled]~.form-check-label{cursor:default;opacity:.5}.form-switch{padding-left:2.5em}.form-switch .form-check-input{--bs-form-switch-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");width:2em;margin-left:-2.5em;background-image:var(--bs-form-switch-bg);background-position:left center;border-radius:2em;transition:background-position .15s ease-in-out}@media (prefers-reduced-motion:reduce){.form-switch .form-check-input{transition:none}}.form-switch .form-check-input:focus{--bs-form-switch-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%2386b7fe'/%3e%3c/svg%3e\")}.form-switch .form-check-input:checked{background-position:right center;--bs-form-switch-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus){--bs-form-switch-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\")}.input-group{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.input-group>.form-control,.input-group>.form-select{position:relative;flex:1 1 auto;width:1%;min-width:0}.input-group>.form-control:focus,.input-group>.form-select:focus{z-index:5}.input-group .btn{position:relative;z-index:2}.input-group .btn:focus{z-index:5}.input-group-text{display:flex;align-items:center;padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:var(--bs-body-color);text-align:center;white-space:nowrap;background-color:var(--bs-tertiary-bg);border:var(--bs-border-width) solid var(--bs-border-color);border-radius:var(--bs-border-radius)}.input-group:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating){border-top-right-radius:0;border-bottom-right-radius:0}.input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(\r.invalid-feedback\r){margin-left:calc(var(--bs-border-width) * -1);border-top-left-radius:0;border-bottom-left-radius:0}.btn{--bs-btn-padding-x:0.75rem;--bs-btn-padding-y:0.375rem;--bs-btn-font-family: ;--bs-btn-font-size:1rem;--bs-btn-font-weight:400;--bs-btn-line-height:1.5;--bs-btn-color:var(--bs-body-color);--bs-btn-bg:transparent;--bs-btn-border-width:var(--bs-border-width);--bs-btn-border-color:transparent;--bs-btn-border-radius:var(--bs-border-radius);--bs-btn-hover-border-color:transparent;--bs-btn-box-shadow:inset 0 1px 0 rgba(255, 255, 255, 0.15),0 1px 1px rgba(0, 0, 0, 0.075);--bs-btn-disabled-opacity:0.65;--bs-btn-focus-box-shadow:0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), 0.5);display:inline-block;padding:var(--bs-btn-padding-y) var(--bs-btn-padding-x);font-family:var(--bs-btn-font-family);font-size:var(--bs-btn-font-size);font-weight:var(--bs-btn-font-weight);line-height:var(--bs-btn-line-height);color:var(--bs-btn-color);text-align:center;text-decoration:none;vertical-align:middle;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none;border:var(--bs-btn-border-width) solid var(--bs-btn-border-color);border-radius:var(--bs-btn-border-radius);background-color:var(--bs-btn-bg);transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out}@media (prefers-reduced-motion:reduce){.btn{transition:none}}.btn:hover{color:var(--bs-btn-hover-color);background-color:var(--bs-btn-hover-bg);border-color:var(--bs-btn-hover-border-color)}.btn:focus-visible{color:var(--bs-btn-hover-color);background-color:var(--bs-btn-hover-bg);border-color:var(--bs-btn-hover-border-color);outline:0;box-shadow:var(--bs-btn-focus-box-shadow)}.btn.active,.btn.show,.btn:first-child:active,:not(.btn-check)+.btn:active{color:var(--bs-btn-active-color);background-color:var(--bs-btn-active-bg);border-color:var(--bs-btn-active-border-color)}.btn.active:focus-visible,.btn.show:focus-visible,.btn:first-child:active:focus-visible,:not(.btn-check)+.btn:active:focus-visible{box-shadow:var(--bs-btn-focus-box-shadow)}.btn.disabled,.btn:disabled,fieldset:disabled .btn{color:var(--bs-btn-disabled-color);pointer-events:none;background-color:var(--bs-btn-disabled-bg);border-color:var(--bs-btn-disabled-border-color);opacity:var(--bs-btn-disabled-opacity)}.btn-primary{--bs-btn-color:#fff;--bs-btn-bg:#0d6efd;--bs-btn-border-color:#0d6efd;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#0b5ed7;--bs-btn-hover-border-color:#0a58ca;--bs-btn-focus-shadow-rgb:49,132,253;--bs-btn-active-color:#fff;--bs-btn-active-bg:#0a58ca;--bs-btn-active-border-color:#0a53be;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#fff;--bs-btn-disabled-bg:#0d6efd;--bs-btn-disabled-border-color:#0d6efd}.btn-secondary{--bs-btn-color:#fff;--bs-btn-bg:#6c757d;--bs-btn-border-color:#6c757d;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#5c636a;--bs-btn-hover-border-color:#565e64;--bs-btn-focus-shadow-rgb:130,138,145;--bs-btn-active-color:#fff;--bs-btn-active-bg:#565e64;--bs-btn-active-border-color:#51585e;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#fff;--bs-btn-disabled-bg:#6c757d;--bs-btn-disabled-border-color:#6c757d}.btn-danger{--bs-btn-color:#fff;--bs-btn-bg:#dc3545;--bs-btn-border-color:#dc3545;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#bb2d3b;--bs-btn-hover-border-color:#b02a37;--bs-btn-focus-shadow-rgb:225,83,97;--bs-btn-active-color:#fff;--bs-btn-active-bg:#b02a37;--bs-btn-active-border-color:#a52834;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#fff;--bs-btn-disabled-bg:#dc3545;--bs-btn-disabled-border-color:#dc3545}.btn-outline-secondary{--bs-btn-color:#6c757d;--bs-btn-border-color:#6c757d;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#6c757d;--bs-btn-hover-border-color:#6c757d;--bs-btn-focus-shadow-rgb:108,117,125;--bs-btn-active-color:#fff;--bs-btn-active-bg:#6c757d;--bs-btn-active-border-color:#6c757d;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#6c757d;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#6c757d;--bs-gradient:none}.btn-outline-danger{--bs-btn-color:#dc3545;--bs-btn-border-color:#dc3545;--bs-btn-hover-color:#fff;--bs-btn-hover-bg:#dc3545;--bs-btn-hover-border-color:#dc3545;--bs-btn-focus-shadow-rgb:220,53,69;--bs-btn-active-color:#fff;--bs-btn-active-bg:#dc3545;--bs-btn-active-border-color:#dc3545;--bs-btn-active-shadow:inset 0 3px 5px rgba(0, 0, 0, 0.125);--bs-btn-disabled-color:#dc3545;--bs-btn-disabled-bg:transparent;--bs-btn-disabled-border-color:#dc3545;--bs-gradient:none}.btn-link{--bs-btn-font-weight:400;--bs-btn-color:var(--bs-link-color);--bs-btn-bg:transparent;--bs-btn-border-color:transparent;--bs-btn-hover-color:var(--bs-link-hover-color);--bs-btn-hover-border-color:transparent;--bs-btn-active-color:var(--bs-link-hover-color);--bs-btn-active-border-color:transparent;--bs-btn-disabled-color:#6c757d;--bs-btn-disabled-border-color:transparent;--bs-btn-box-shadow:0 0 0 #000;--bs-btn-focus-shadow-rgb:49,132,253;text-decoration:underline}.btn-link:focus-visible{color:var(--bs-btn-color)}.btn-link:hover{color:var(--bs-btn-hover-color)}.fade{transition:opacity .15s linear}@media (prefers-reduced-motion:reduce){.fade{transition:none}}.fade:not(.show){opacity:0}.collapse:not(.show){display:none}.dropdown{position:relative}.nav{--bs-nav-link-padding-x:1rem;--bs-nav-link-padding-y:0.5rem;--bs-nav-link-font-weight: ;--bs-nav-link-color:var(--bs-link-color);--bs-nav-link-hover-color:var(--bs-link-hover-color);--bs-nav-link-disabled-color:var(--bs-secondary-color);display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:block;padding:var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);font-size:var(--bs-nav-link-font-size);font-weight:var(--bs-nav-link-font-weight);color:var(--bs-nav-link-color);text-decoration:none;background:0 0;border:0;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out}@media (prefers-reduced-motion:reduce){.nav-link{transition:none}}.nav-link:focus,.nav-link:hover{color:var(--bs-nav-link-hover-color)}.nav-link:focus-visible{outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.nav-link.disabled{color:var(--bs-nav-link-disabled-color);pointer-events:none;cursor:default}.navbar{--bs-navbar-padding-x:0;--bs-navbar-padding-y:0.5rem;--bs-navbar-color:rgba(var(--bs-emphasis-color-rgb), 0.65);--bs-navbar-hover-color:rgba(var(--bs-emphasis-color-rgb), 0.8);--bs-navbar-disabled-color:rgba(var(--bs-emphasis-color-rgb), 0.3);--bs-navbar-active-color:rgba(var(--bs-emphasis-color-rgb), 1);--bs-navbar-brand-padding-y:0.3125rem;--bs-navbar-brand-margin-end:1rem;--bs-navbar-brand-font-size:1.25rem;--bs-navbar-brand-color:rgba(var(--bs-emphasis-color-rgb), 1);--bs-navbar-brand-hover-color:rgba(var(--bs-emphasis-color-rgb), 1);--bs-navbar-nav-link-padding-x:0.5rem;--bs-navbar-toggler-padding-y:0.25rem;--bs-navbar-toggler-padding-x:0.75rem;--bs-navbar-toggler-font-size:1.25rem;--bs-navbar-toggler-icon-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2833, 37, 41, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");--bs-navbar-toggler-border-color:rgba(var(--bs-emphasis-color-rgb), 0.15);--bs-navbar-toggler-border-radius:var(--bs-border-radius);--bs-navbar-toggler-focus-width:0.25rem;--bs-navbar-toggler-transition:box-shadow 0.15s ease-in-out;position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding:var(--bs-navbar-padding-y) var(--bs-navbar-padding-x)}.navbar>.container,.navbar>.container-fluid{display:flex;flex-wrap:inherit;align-items:center;justify-content:space-between}.navbar-brand{padding-top:var(--bs-navbar-brand-padding-y);padding-bottom:var(--bs-navbar-brand-padding-y);margin-right:var(--bs-navbar-brand-margin-end);font-size:var(--bs-navbar-brand-font-size);color:var(--bs-navbar-brand-color);text-decoration:none;white-space:nowrap}.navbar-brand:focus,.navbar-brand:hover{color:var(--bs-navbar-brand-hover-color)}.navbar-nav{--bs-nav-link-padding-x:0;--bs-nav-link-padding-y:0.5rem;--bs-nav-link-font-weight: ;--bs-nav-link-color:var(--bs-navbar-color);--bs-nav-link-hover-color:var(--bs-navbar-hover-color);--bs-nav-link-disabled-color:var(--bs-navbar-disabled-color);display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.navbar-nav .nav-link.active,.navbar-nav .nav-link.show{color:var(--bs-navbar-active-color)}.navbar-collapse{flex-basis:100%;flex-grow:1;align-items:center}.navbar-toggler{padding:var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);font-size:var(--bs-navbar-toggler-font-size);line-height:1;color:var(--bs-navbar-color);background-color:transparent;border:var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);border-radius:var(--bs-navbar-toggler-border-radius);transition:var(--bs-navbar-toggler-transition)}@media (prefers-reduced-motion:reduce){.navbar-toggler{transition:none}}.navbar-toggler:hover{text-decoration:none}.navbar-toggler:focus{text-decoration:none;outline:0;box-shadow:0 0 0 var(--bs-navbar-toggler-focus-width)}.navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;background-image:var(--bs-navbar-toggler-icon-bg);background-repeat:no-repeat;background-position:center;background-size:100%}@media (min-width:992px){.navbar-expand-lg{flex-wrap:nowrap;justify-content:flex-start}.navbar-expand-lg .navbar-nav{flex-direction:row}.navbar-expand-lg .navbar-nav .nav-link{padding-right:var(--bs-navbar-nav-link-padding-x);padding-left:var(--bs-navbar-nav-link-padding-x)}.navbar-expand-lg .navbar-collapse{display:flex!important;flex-basis:auto}.navbar-expand-lg .navbar-toggler{display:none}.navbar-expand-lg .offcanvas{position:static;z-index:auto;flex-grow:1;width:auto!important;height:auto!important;visibility:visible!important;background-color:transparent!important;border:0!important;transform:none!important;transition:none}}[data-bs-theme=dark] .navbar-toggler-icon{--bs-navbar-toggler-icon-bg:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.card{--bs-card-spacer-y:1rem;--bs-card-spacer-x:1rem;--bs-card-title-spacer-y:0.5rem;--bs-card-title-color: ;--bs-card-subtitle-color: ;--bs-card-border-width:var(--bs-border-width);--bs-card-border-color:var(--bs-border-color-translucent);--bs-card-border-radius:var(--bs-border-radius);--bs-card-box-shadow: ;--bs-card-inner-border-radius:calc(var(--bs-border-radius) - (var(--bs-border-width)));--bs-card-cap-padding-y:0.5rem;--bs-card-cap-padding-x:1rem;--bs-card-cap-bg:rgba(var(--bs-body-color-rgb), 0.03);--bs-card-cap-color: ;--bs-card-height: ;--bs-card-color: ;--bs-card-bg:var(--bs-body-bg);--bs-card-img-overlay-padding:1rem;--bs-card-group-margin:0.75rem;position:relative;display:flex;flex-direction:column;min-width:0;height:var(--bs-card-height);color:var(--bs-body-color);word-wrap:break-word;background-color:var(--bs-card-bg);background-clip:border-box;border:var(--bs-card-border-width) solid var(--bs-card-border-color);border-radius:var(--bs-card-border-radius)}.card>hr{margin-right:0;margin-left:0}.accordion{--bs-accordion-color:var(--bs-body-color);--bs-accordion-bg:var(--bs-body-bg);--bs-accordion-transition:color 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,border-radius 0.15s ease;--bs-accordion-border-color:var(--bs-border-color);--bs-accordion-border-width:var(--bs-border-width);--bs-accordion-border-radius:var(--bs-border-radius);--bs-accordion-inner-border-radius:calc(var(--bs-border-radius) - (var(--bs-border-width)));--bs-accordion-btn-padding-x:1.25rem;--bs-accordion-btn-padding-y:1rem;--bs-accordion-btn-color:var(--bs-body-color);--bs-accordion-btn-bg:var(--bs-accordion-bg);--bs-accordion-btn-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");--bs-accordion-btn-icon-width:1.25rem;--bs-accordion-btn-icon-transform:rotate(-180deg);--bs-accordion-btn-icon-transition:transform 0.2s ease-in-out;--bs-accordion-btn-active-icon:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23052c65'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");--bs-accordion-btn-focus-border-color:#86b7fe;--bs-accordion-btn-focus-box-shadow:0 0 0 0.25rem rgba(13, 110, 253, 0.25);--bs-accordion-body-padding-x:1.25rem;--bs-accordion-body-padding-y:1rem;--bs-accordion-active-color:var(--bs-primary-text-emphasis);--bs-accordion-active-bg:var(--bs-primary-bg-subtle)}.badge{--bs-badge-padding-x:0.65em;--bs-badge-padding-y:0.35em;--bs-badge-font-size:0.75em;--bs-badge-font-weight:700;--bs-badge-color:#fff;--bs-badge-border-radius:var(--bs-border-radius);display:inline-block;padding:var(--bs-badge-padding-y) var(--bs-badge-padding-x);font-size:var(--bs-badge-font-size);font-weight:var(--bs-badge-font-weight);line-height:1;color:var(--bs-badge-color);text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:var(--bs-badge-border-radius)}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.alert{--bs-alert-bg:transparent;--bs-alert-padding-x:1rem;--bs-alert-padding-y:1rem;--bs-alert-margin-bottom:1rem;--bs-alert-color:inherit;--bs-alert-border-color:transparent;--bs-alert-border:var(--bs-border-width) solid var(--bs-alert-border-color);--bs-alert-border-radius:var(--bs-border-radius);--bs-alert-link-color:inherit;position:relative;padding:var(--bs-alert-padding-y) var(--bs-alert-padding-x);margin-bottom:var(--bs-alert-margin-bottom);color:var(--bs-alert-color);background-color:var(--bs-alert-bg);border:var(--bs-alert-border);border-radius:var(--bs-alert-border-radius)}@keyframes progress-bar-stripes{0%{background-position-x:1rem}}.progress{--bs-progress-height:1rem;--bs-progress-font-size:0.75rem;--bs-progress-bg:var(--bs-secondary-bg);--bs-progress-border-radius:var(--bs-border-radius);--bs-progress-box-shadow:var(--bs-box-shadow-inset);--bs-progress-bar-color:#fff;--bs-progress-bar-bg:#0d6efd;--bs-progress-bar-transition:width 0.6s ease;display:flex;height:var(--bs-progress-height);overflow:hidden;font-size:var(--bs-progress-font-size);background-color:var(--bs-progress-bg);border-radius:var(--bs-progress-border-radius)}.toast{--bs-toast-zindex:1090;--bs-toast-padding-x:0.75rem;--bs-toast-padding-y:0.5rem;--bs-toast-spacing:1.5rem;--bs-toast-max-width:350px;--bs-toast-font-size:0.875rem;--bs-toast-color: ;--bs-toast-bg:rgba(var(--bs-body-bg-rgb), 0.85);--bs-toast-border-width:var(--bs-border-width);--bs-toast-border-color:var(--bs-border-color-translucent);--bs-toast-border-radius:var(--bs-border-radius);--bs-toast-box-shadow:var(--bs-box-shadow);--bs-toast-header-color:var(--bs-secondary-color);--bs-toast-header-bg:rgba(var(--bs-body-bg-rgb), 0.85);--bs-toast-header-border-color:var(--bs-border-color-translucent);width:var(--bs-toast-max-width);max-width:100%;font-size:var(--bs-toast-font-size);color:var(--bs-toast-color);pointer-events:auto;background-color:var(--bs-toast-bg);background-clip:padding-box;border:var(--bs-toast-border-width) solid var(--bs-toast-border-color);box-shadow:var(--bs-toast-box-shadow);border-radius:var(--bs-toast-border-radius)}.toast.showing{opacity:0}.toast:not(.show){display:none}.modal{--bs-modal-zindex:1055;--bs-modal-width:500px;--bs-modal-padding:1rem;--bs-modal-margin:0.5rem;--bs-modal-color: ;--bs-modal-bg:var(--bs-body-bg);--bs-modal-border-color:var(--bs-border-color-translucent);--bs-modal-border-width:var(--bs-border-width);--bs-modal-border-radius:var(--bs-border-radius-lg);--bs-modal-box-shadow:0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);--bs-modal-inner-border-radius:calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));--bs-modal-header-padding-x:1rem;--bs-modal-header-padding-y:1rem;--bs-modal-header-padding:1rem 1rem;--bs-modal-header-border-color:var(--bs-border-color);--bs-modal-header-border-width:var(--bs-border-width);--bs-modal-title-line-height:1.5;--bs-modal-footer-gap:0.5rem;--bs-modal-footer-bg: ;--bs-modal-footer-border-color:var(--bs-border-color);--bs-modal-footer-border-width:var(--bs-border-width);position:fixed;top:0;left:0;z-index:var(--bs-modal-zindex);display:none;width:100%;height:100%;overflow-x:hidden;overflow-y:auto;outline:0}.modal-content{position:relative;display:flex;flex-direction:column;width:100%;color:var(--bs-modal-color);pointer-events:auto;background-color:var(--bs-modal-bg);background-clip:padding-box;border:var(--bs-modal-border-width) solid var(--bs-modal-border-color);border-radius:var(--bs-modal-border-radius);outline:0}.modal-backdrop{--bs-backdrop-zindex:1050;--bs-backdrop-bg:#000;--bs-backdrop-opacity:0.5;position:fixed;top:0;left:0;z-index:var(--bs-backdrop-zindex);width:100vw;height:100vh;background-color:var(--bs-backdrop-bg)}.modal-backdrop.fade{opacity:0}.modal-backdrop.show{opacity:var(--bs-backdrop-opacity)}.modal-footer{display:flex;flex-shrink:0;flex-wrap:wrap;align-items:center;justify-content:flex-end;padding:calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * .5);background-color:var(--bs-modal-footer-bg);border-top:var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);border-bottom-right-radius:var(--bs-modal-inner-border-radius);border-bottom-left-radius:var(--bs-modal-inner-border-radius)}.modal-footer>*{margin:calc(var(--bs-modal-footer-gap) * .5)}@media (min-width:576px){.modal{--bs-modal-margin:1.75rem;--bs-modal-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15)}}.tooltip{--bs-tooltip-zindex:1080;--bs-tooltip-max-width:200px;--bs-tooltip-padding-x:0.5rem;--bs-tooltip-padding-y:0.25rem;--bs-tooltip-margin: ;--bs-tooltip-font-size:0.875rem;--bs-tooltip-color:var(--bs-body-bg);--bs-tooltip-bg:var(--bs-emphasis-color);--bs-tooltip-border-radius:var(--bs-border-radius);--bs-tooltip-opacity:0.9;--bs-tooltip-arrow-width:0.8rem;--bs-tooltip-arrow-height:0.4rem;z-index:var(--bs-tooltip-zindex);display:block;margin:var(--bs-tooltip-margin);font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;white-space:normal;word-spacing:normal;line-break:auto;font-size:var(--bs-tooltip-font-size);word-wrap:break-word;opacity:0}.tooltip.show{opacity:var(--bs-tooltip-opacity)}.tooltip .tooltip-arrow{display:block;width:var(--bs-tooltip-arrow-width);height:var(--bs-tooltip-arrow-height)}.tooltip .tooltip-arrow::before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.tooltip-inner{max-width:var(--bs-tooltip-max-width);padding:var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);color:var(--bs-tooltip-color);text-align:center;background-color:var(--bs-tooltip-bg);border-radius:var(--bs-tooltip-border-radius)}.popover{--bs-popover-zindex:1070;--bs-popover-max-width:276px;--bs-popover-font-size:0.875rem;--bs-popover-bg:var(--bs-body-bg);--bs-popover-border-width:var(--bs-border-width);--bs-popover-border-color:var(--bs-border-color-translucent);--bs-popover-border-radius:var(--bs-border-radius-lg);--bs-popover-inner-border-radius:calc(var(--bs-border-radius-lg) - var(--bs-border-width));--bs-popover-box-shadow:0 0.5rem 1rem rgba(0, 0, 0, 0.15);--bs-popover-header-padding-x:1rem;--bs-popover-header-padding-y:0.5rem;--bs-popover-header-font-size:1rem;--bs-popover-header-color: ;--bs-popover-header-bg:var(--bs-secondary-bg);--bs-popover-body-padding-x:1rem;--bs-popover-body-padding-y:1rem;--bs-popover-body-color:var(--bs-body-color);--bs-popover-arrow-width:1rem;--bs-popover-arrow-height:0.5rem;--bs-popover-arrow-border:var(--bs-popover-border-color);z-index:var(--bs-popover-zindex);display:block;max-width:var(--bs-popover-max-width);font-family:var(--bs-font-sans-serif);font-style:normal;font-weight:400;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;white-space:normal;word-spacing:normal;line-break:auto;font-size:var(--bs-popover-font-size);word-wrap:break-word;background-color:var(--bs-popover-bg);background-clip:padding-box;border:var(--bs-popover-border-width) solid var(--bs-popover-border-color);border-radius:var(--bs-popover-border-radius)}.carousel{position:relative}@keyframes spinner-border{to{transform:rotate(360deg)}}@keyframes spinner-grow{0%{transform:scale(0)}50%{opacity:1;transform:none}}.offcanvas{--bs-offcanvas-zindex:1045;--bs-offcanvas-width:400px;--bs-offcanvas-height:30vh;--bs-offcanvas-padding-x:1rem;--bs-offcanvas-padding-y:1rem;--bs-offcanvas-color:var(--bs-body-color);--bs-offcanvas-bg:var(--bs-body-bg);--bs-offcanvas-border-width:var(--bs-border-width);--bs-offcanvas-border-color:var(--bs-border-color-translucent);--bs-offcanvas-box-shadow:0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);--bs-offcanvas-transition:transform 0.3s ease-in-out;--bs-offcanvas-title-line-height:1.5}.offcanvas{position:fixed;bottom:0;z-index:var(--bs-offcanvas-zindex);display:flex;flex-direction:column;max-width:100%;color:var(--bs-offcanvas-color);visibility:hidden;background-color:var(--bs-offcanvas-bg);background-clip:padding-box;outline:0;transition:var(--bs-offcanvas-transition)}@media (prefers-reduced-motion:reduce){.offcanvas{transition:none}}.offcanvas.show:not(.hiding),.offcanvas.showing{transform:none}.offcanvas.hiding,.offcanvas.show,.offcanvas.showing{visibility:visible}.placeholder{display:inline-block;min-height:1em;vertical-align:middle;cursor:wait;background-color:currentcolor;opacity:.5}.placeholder.btn::before{display:inline-block;content:\"\"}@keyframes placeholder-glow{50%{opacity:.2}}@keyframes placeholder-wave{100%{-webkit-mask-position:-200% 0%;mask-position:-200% 0%}}.ratio{position:relative;width:100%}.ratio::before{display:block;padding-top:var(--bs-aspect-ratio);content:\"\"}.ratio>*{position:absolute;top:0;left:0;width:100%;height:100%}.align-text-top{vertical-align:text-top!important}.d-inline-block{display:inline-block!important}.shadow{box-shadow:0 .5rem 1rem rgba(0,0,0,.15)!important}.border{border:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important}.border-top{border-top:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important}.border-bottom{border-bottom:var(--bs-border-width) var(--bs-border-style) var(--bs-border-color)!important}.flex-wrap{flex-wrap:wrap!important}.m-3{margin:1rem!important}.mx-1{margin-right:.25rem!important;margin-left:.25rem!important}.mx-2{margin-right:.5rem!important;margin-left:.5rem!important}.mx-3{margin-right:1rem!important;margin-left:1rem!important}.my-1{margin-top:.25rem!important;margin-bottom:.25rem!important}.my-2{margin-top:.5rem!important;margin-bottom:.5rem!important}.my-3{margin-top:1rem!important;margin-bottom:1rem!important}.me-2{margin-right:.5rem!important}.me-auto{margin-right:auto!important}.mb-2{margin-bottom:.5rem!important}.mb-3{margin-bottom:1rem!important}.p-3{padding:1rem!important}.text-wrap{white-space:normal!important}.bg-body-tertiary{--bs-bg-opacity:1;background-color:rgba(var(--bs-tertiary-bg-rgb),var(--bs-bg-opacity))!important}.rounded{border-radius:var(--bs-border-radius)!important}.visible{visibility:visible!important}.invisible{visibility:hidden!important}@media (min-width:992px){.d-lg-none{display:none!important}.mb-lg-0{margin-bottom:0!important}}";
const $f28607f65f09ab1c$export$995990c5c04c46f0 = (0, $bZWYA.create)($f28607f65f09ab1c$export$6f093cfa640b7166, "file:///src/view/styles/bootstrap.part.css.js");

});

parcelRegister("iTeYD", function(module, exports) {

$parcel$export(module.exports, "sheet", () => $dc08fb307268061f$export$995990c5c04c46f0);

var $bZWYA = parcelRequire("bZWYA");
let $dc08fb307268061f$export$6f093cfa640b7166 = ".title{margin:.5em 1em;padding:.5em 1em;border-bottom:1px var(--bs-border-color) solid}.title::before{display:block;content:\" \";position:absolute;left:1.25em;width:.125em;height:1.4em;background-color:var(--bs-primary)}";
const $dc08fb307268061f$export$995990c5c04c46f0 = (0, $bZWYA.create)($dc08fb307268061f$export$6f093cfa640b7166, "file:///src/view/styles/title.css.js");

});

parcelRegister("jW2zV", function(module, exports) {

$parcel$export(module.exports, "sheet", () => $e8356f1f6e5addf4$export$995990c5c04c46f0);

var $bZWYA = parcelRequire("bZWYA");
let $e8356f1f6e5addf4$export$6f093cfa640b7166 = ":root[data-theme=light]{--pst-border:none;--prs-border:none;--ftr-border:none;--byd-border:none}:root[data-theme=dark]{--pst-border:4px solid var(--pst-border-color);--prs-border:4px solid var(--prs-border-color);--ftr-border:4px solid var(--ftr-border-color);--byd-border:4px solid var(--byd-border-color)}";
const $e8356f1f6e5addf4$export$995990c5c04c46f0 = (0, $bZWYA.create)($e8356f1f6e5addf4$export$6f093cfa640b7166, "file:///src/view/styles/theme.css.js");

});

parcelRegister("jl8dB", function(module, exports) {

$parcel$export(module.exports, "sheet", () => $e1465a7b839ff8b4$export$995990c5c04c46f0);

var $bZWYA = parcelRequire("bZWYA");
let $e1465a7b839ff8b4$export$6f093cfa640b7166 = "table.table td,table.table th{border:var(--bs-border-width) var(--bs-border-color) var(--bs-border-style)}table.table th{background-color:var(--bs-table-striped-bg)}";
const $e1465a7b839ff8b4$export$995990c5c04c46f0 = (0, $bZWYA.create)($e1465a7b839ff8b4$export$6f093cfa640b7166, "file:///src/view/styles/table.css.js");

});

parcelRegister("hB6dd", function(module, exports) {

$parcel$export(module.exports, "sheet", () => $ccfab5fcef240429$export$995990c5c04c46f0);

var $bZWYA = parcelRequire("bZWYA");
let $ccfab5fcef240429$export$6f093cfa640b7166 = "";
const $ccfab5fcef240429$export$995990c5c04c46f0 = (0, $bZWYA.create)($ccfab5fcef240429$export$6f093cfa640b7166, "file:///src/view/styles/view-transition.css.js");

});


parcelRegister("2v1vl", function(module, exports) {

$parcel$export(module.exports, "__esDecorate", () => $695633265d04154d$export$3a84e1ae4e97e9b0);
$parcel$export(module.exports, "__runInitializers", () => $695633265d04154d$export$d831c04e792af3d);
$parcel$export(module.exports, "__setFunctionName", () => $695633265d04154d$export$d1a06452d3489bc7);
$parcel$export(module.exports, "__classPrivateFieldGet", () => $695633265d04154d$export$d5dcaf168c640c35);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $695633265d04154d$var$extendStatics = function(d, b) {
    $695633265d04154d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $695633265d04154d$var$extendStatics(d, b);
};
function $695633265d04154d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $695633265d04154d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $695633265d04154d$export$18ce0697a983be9b = function() {
    $695633265d04154d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $695633265d04154d$export$18ce0697a983be9b.apply(this, arguments);
};
function $695633265d04154d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $695633265d04154d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $695633265d04154d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $695633265d04154d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $695633265d04154d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $695633265d04154d$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $695633265d04154d$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $695633265d04154d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $695633265d04154d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $695633265d04154d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $695633265d04154d$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $695633265d04154d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $695633265d04154d$export$45d3717a4c69092e(o, m, p);
}
function $695633265d04154d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $695633265d04154d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $695633265d04154d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($695633265d04154d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $695633265d04154d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $695633265d04154d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $695633265d04154d$export$10c90e4f7922046c(v) {
    return this instanceof $695633265d04154d$export$10c90e4f7922046c ? (this.v = v, this) : new $695633265d04154d$export$10c90e4f7922046c(v);
}
function $695633265d04154d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $695633265d04154d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $695633265d04154d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $695633265d04154d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $695633265d04154d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $695633265d04154d$export$19a8beecd37a4c45 === "function" ? $695633265d04154d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $695633265d04154d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $695633265d04154d$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $695633265d04154d$var$ownKeys = function(o) {
    $695633265d04154d$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $695633265d04154d$var$ownKeys(o);
};
function $695633265d04154d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $695633265d04154d$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $695633265d04154d$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $695633265d04154d$var$__setModuleDefault(result, mod);
    return result;
}
function $695633265d04154d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $695633265d04154d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $695633265d04154d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $695633265d04154d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $695633265d04154d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $695633265d04154d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $695633265d04154d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $695633265d04154d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $695633265d04154d$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $695633265d04154d$export$2e2bcd8739ae039 = {
    __extends: $695633265d04154d$export$a8ba968b8961cb8a,
    __assign: $695633265d04154d$export$18ce0697a983be9b,
    __rest: $695633265d04154d$export$3c9a16f847548506,
    __decorate: $695633265d04154d$export$29e00dfd3077644b,
    __param: $695633265d04154d$export$d5ad3fd78186038f,
    __esDecorate: $695633265d04154d$export$3a84e1ae4e97e9b0,
    __runInitializers: $695633265d04154d$export$d831c04e792af3d,
    __propKey: $695633265d04154d$export$6a2a36740a146cb8,
    __setFunctionName: $695633265d04154d$export$d1a06452d3489bc7,
    __metadata: $695633265d04154d$export$f1db080c865becb9,
    __awaiter: $695633265d04154d$export$1050f835b63b671e,
    __generator: $695633265d04154d$export$67ebef60e6f28a6,
    __createBinding: $695633265d04154d$export$45d3717a4c69092e,
    __exportStar: $695633265d04154d$export$f33643c0debef087,
    __values: $695633265d04154d$export$19a8beecd37a4c45,
    __read: $695633265d04154d$export$8d051b38c9118094,
    __spread: $695633265d04154d$export$afc72e2116322959,
    __spreadArrays: $695633265d04154d$export$6388937ca91ccae8,
    __spreadArray: $695633265d04154d$export$1216008129fb82ed,
    __await: $695633265d04154d$export$10c90e4f7922046c,
    __asyncGenerator: $695633265d04154d$export$e427f37a30a4de9b,
    __asyncDelegator: $695633265d04154d$export$bbd80228419bb833,
    __asyncValues: $695633265d04154d$export$e3b29a3d6162315f,
    __makeTemplateObject: $695633265d04154d$export$4fb47efe1390b86f,
    __importStar: $695633265d04154d$export$c21735bcef00d192,
    __importDefault: $695633265d04154d$export$da59b14a69baef04,
    __classPrivateFieldGet: $695633265d04154d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $695633265d04154d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $695633265d04154d$export$81fdc39f203e4e04,
    __addDisposableResource: $695633265d04154d$export$88ac25d8e944e405,
    __disposeResources: $695633265d04154d$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $695633265d04154d$export$889dfb5d17574b0b
};

});

parcelRegister("8ght1", function(module, exports) {

$parcel$export(module.exports, "token", () => $603d5df44b303659$export$9e1725a4cfeada27);
$parcel$export(module.exports, "Injectable", () => $603d5df44b303659$export$f27950dda4c163f1);
$parcel$export(module.exports, "Container", () => $603d5df44b303659$export$42a852a2b6b56249);
const $603d5df44b303659$export$9e1725a4cfeada27 = (e, t)=>({
        type: "token",
        key: Symbol(e),
        default: t
    }), $603d5df44b303659$export$62a0befd656d626f = Symbol.for("classic-di-metadata"), $603d5df44b303659$export$f27950dda4c163f1 = (e)=>(n, s)=>{
        const o = s.metadata;
        if (!o) throw new Error('`metadata` not found in decorator context. Forgot to polyfill "Symbol.metadata"?');
        o[$603d5df44b303659$export$62a0befd656d626f] = e;
    };
var $603d5df44b303659$export$1930a40dd9747c94, $603d5df44b303659$var$o;
!function(e) {
    e[e.Create = 0] = "Create", e[e.Instance = 1] = "Instance", e[e.Reference = 2] = "Reference";
}($603d5df44b303659$export$1930a40dd9747c94 || ($603d5df44b303659$export$1930a40dd9747c94 = {})), function(e) {
    e[e.Resolving = 1] = "Resolving", e[e.Resolved = 2] = "Resolved";
}($603d5df44b303659$var$o || ($603d5df44b303659$var$o = {}));
class $603d5df44b303659$export$42a852a2b6b56249 {
    #e = new Map;
    #t = new Map;
    #n;
    name;
    constructor(e){
        this.#n = e?.parent, this.name = e?.name;
    }
    add(e, t) {
        const n = e.key;
        if (this.#t.has(n)) throw new Error(`Instance of ${n.description} already exist.`);
        this.#t.set(n, t);
    }
    register(e) {
        const t = this.#s(e);
        if (!t) throw new Error(`No metadata found on ${e.name}.  Forgot to decorate with "Injectable" or polyfill "Symbol.metadata"?`);
        const n = t.implements;
        if (!n) throw new Error("Implementation token is required.");
        const { key: s } = n;
        if (this.#e.has(s)) throw new Error(`Cannot register "${s.description}" twice.`);
        this.#e.set(s, e);
    }
    resolve(e) {
        const t = new Map, n = this.#o(e);
        if (n.type === $603d5df44b303659$export$1930a40dd9747c94.Instance) return {
            circular: !1,
            path: [
                n
            ]
        };
        {
            const { token: e } = n;
            e && t.set(e.key, {
                state: $603d5df44b303659$var$o.Resolving,
                index: 0,
                node: n
            });
        }
        const r = [
            {
                node: n,
                index: -1
            }
        ], a = [];
        for(let e = r.at(-1); e; e = r.at(-1)){
            const { node: n } = e, i = ++e.index, { deps: c, token: l } = n;
            if (i === c.length) a.push(n), r.pop(), l && t.set(l.key, {
                state: $603d5df44b303659$var$o.Resolved,
                node: n
            });
            else {
                const e = c[i], { key: n } = e, d = t.get(n);
                if (d) {
                    if (d.state === $603d5df44b303659$var$o.Resolving) {
                        const e = r.map((e)=>e.node);
                        return e.push(d.node), {
                            circular: !0,
                            begin: d.index,
                            path: e
                        };
                    }
                    a.push({
                        type: $603d5df44b303659$export$1930a40dd9747c94.Reference,
                        owner: this,
                        token: l,
                        node: d.node
                    });
                    continue;
                }
                const h = this.#r(e);
                h.type === $603d5df44b303659$export$1930a40dd9747c94.Instance ? a.push(h) : (t.set(n, {
                    state: $603d5df44b303659$var$o.Resolving,
                    index: r.length,
                    node: h
                }), r.push({
                    node: h,
                    index: -1
                }));
            }
        }
        return {
            circular: !1,
            path: a
        };
    }
    create(e) {
        const t = [];
        for(let n = 0, o = e.length; n < o; n++){
            const o = e[n];
            if (o.type === $603d5df44b303659$export$1930a40dd9747c94.Instance) t.push(o.instance);
            else if (o.type === $603d5df44b303659$export$1930a40dd9747c94.Create) {
                const { ctor: e, deps: { length: n }, owner: s, token: r } = o, a = t.slice(t.length - n), i = s.createInstance(e, a);
                r && s.#t.set(r.key, i), t.length -= n, t.push(i), o.instance = i;
            } else o.type === $603d5df44b303659$export$1930a40dd9747c94.Reference && t.push(o.node.instance);
        }
        return t[0];
    }
    get(e) {
        return this.#a(e);
    }
    consume(e) {
        return this.#a(e);
    }
    createInstance(e, t) {
        return Reflect.construct(e, t);
    }
    #s(e) {
        return e[Symbol.metadata]?.[$603d5df44b303659$export$62a0befd656d626f];
    }
    #o(e) {
        if ("function" == typeof e) {
            const t = this.#s(e);
            if (!t) throw new Error(`Injectable metadata not found on "${e.name}".`);
            const { implements: n } = t;
            return n && this.#e.get(n.key) === e ? this.#r(n) : {
                type: $603d5df44b303659$export$1930a40dd9747c94.Create,
                owner: this,
                token: null,
                ctor: e,
                deps: t.requires ?? []
            };
        }
        return this.#r(e);
    }
    #r(e) {
        const { key: t } = e, n = this.#t.get(t);
        if (n) return {
            type: $603d5df44b303659$export$1930a40dd9747c94.Instance,
            token: e,
            owner: this,
            instance: n
        };
        const o = this.#e.get(t);
        if (o) return {
            type: $603d5df44b303659$export$1930a40dd9747c94.Create,
            token: e,
            owner: this,
            ctor: o,
            deps: this.#s(o).requires ?? []
        };
        const r = e.default;
        if (r) return {
            type: $603d5df44b303659$export$1930a40dd9747c94.Instance,
            token: e,
            owner: this,
            instance: r
        };
        const a = this.#n;
        if (!a) throw new Error(`Cannot resolve "${t.description}".`);
        return a.#r(e);
    }
    #a(e) {
        const t = this.resolve(e);
        if (t.circular) throw new $603d5df44b303659$export$ffb95e925976b2fe(t);
        return this.create(t.path);
    }
}
class $603d5df44b303659$export$ffb95e925976b2fe extends Error {
    resolution;
    constructor(e){
        super(`Circular dependency: ${e.path.map((t, n)=>{
            const s = t.token?.key.description;
            return `${n === e.begin ? "{{ " : ""}[${s ? `<${s}> ` : ""}${t.ctor.name}]`;
        }).join(" -> ")} }}`), this.resolution = e;
    }
}

});

parcelRegister("LBO4U", function(module, exports) {

$parcel$export(module.exports, "LogLevel", () => $08f1b786dc078b00$export$243e62d78d3b544d);
$parcel$export(module.exports, "$LowLevelStorage", () => $08f1b786dc078b00$export$a136bea102b2ef6f);
$parcel$export(module.exports, "$Logger", () => $08f1b786dc078b00$export$1d7355c71f31be4f);
$parcel$export(module.exports, "$Database", () => $08f1b786dc078b00$export$bb7a270a88d37fcf);
$parcel$export(module.exports, "$PreferenceService", () => $08f1b786dc078b00$export$1bd7826c7cb1ba6c);
$parcel$export(module.exports, "$CoreDataService", () => $08f1b786dc078b00$export$b792c3a317f692a9);
$parcel$export(module.exports, "$CoreDataProvider", () => $08f1b786dc078b00$export$f87e84017115cdf3);
$parcel$export(module.exports, "$AssetsResolver", () => $08f1b786dc078b00$export$5f5d8d18731043e9);
$parcel$export(module.exports, "$AssetsService", () => $08f1b786dc078b00$export$24117da5c1be0359);
$parcel$export(module.exports, "$AssetsCacheService", () => $08f1b786dc078b00$export$84ef7372728028a8);
$parcel$export(module.exports, "$FileStorage", () => $08f1b786dc078b00$export$37c0c1c0eeebbffd);
$parcel$export(module.exports, "$Gateway", () => $08f1b786dc078b00$export$c4117ee02540f1b4);
$parcel$export(module.exports, "$CharacterService", () => $08f1b786dc078b00$export$42e1babfb3d46231);
$parcel$export(module.exports, "$ChartService", () => $08f1b786dc078b00$export$13204243ab693e14);
$parcel$export(module.exports, "$MusicPlayService", () => $08f1b786dc078b00$export$abf7d1059efef8f);
$parcel$export(module.exports, "$ProfileService", () => $08f1b786dc078b00$export$d8178d746cebc02);
$parcel$export(module.exports, "$WorldModeService", () => $08f1b786dc078b00$export$c5cea3dd20ef968a);
$parcel$export(module.exports, "$CrossSiteScriptPluginService", () => $08f1b786dc078b00$export$88fb052570211665);

var $8ght1 = parcelRequire("8ght1");
var $08f1b786dc078b00$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["Debug"] = 0] = "Debug";
    LogLevel[LogLevel["Info"] = 1] = "Info";
    LogLevel[LogLevel["Warning"] = 2] = "Warning";
    LogLevel[LogLevel["Error"] = 3] = "Error";
    LogLevel[LogLevel["Fatal"] = 4] = "Fatal";
})($08f1b786dc078b00$export$243e62d78d3b544d || ($08f1b786dc078b00$export$243e62d78d3b544d = {}));
const $08f1b786dc078b00$export$a136bea102b2ef6f = (0, $8ght1.token)("low-level-storage");
const $08f1b786dc078b00$export$1d7355c71f31be4f = (0, $8ght1.token)("logger");
const $08f1b786dc078b00$export$bb7a270a88d37fcf = (0, $8ght1.token)("database");
const $08f1b786dc078b00$export$1bd7826c7cb1ba6c = (0, $8ght1.token)("preference");
const $08f1b786dc078b00$export$b792c3a317f692a9 = (0, $8ght1.token)("core-data");
const $08f1b786dc078b00$export$f87e84017115cdf3 = (0, $8ght1.token)("core-data-provider");
const $08f1b786dc078b00$export$5f5d8d18731043e9 = (0, $8ght1.token)("assets-resolver");
const $08f1b786dc078b00$export$24117da5c1be0359 = (0, $8ght1.token)("assets");
const $08f1b786dc078b00$export$84ef7372728028a8 = (0, $8ght1.token)("assets-cache");
const $08f1b786dc078b00$export$37c0c1c0eeebbffd = (0, $8ght1.token)("file-storage");
const $08f1b786dc078b00$export$c4117ee02540f1b4 = (0, $8ght1.token)("gateway");
const $08f1b786dc078b00$export$42e1babfb3d46231 = (0, $8ght1.token)("character");
const $08f1b786dc078b00$export$13204243ab693e14 = (0, $8ght1.token)("chart");
const $08f1b786dc078b00$export$abf7d1059efef8f = (0, $8ght1.token)("music-play");
const $08f1b786dc078b00$export$d8178d746cebc02 = (0, $8ght1.token)("profile");
const $08f1b786dc078b00$export$c5cea3dd20ef968a = (0, $8ght1.token)("world-mode");
const $08f1b786dc078b00$export$88fb052570211665 = (0, $8ght1.token)("cross-site-script");

});

parcelRegister("jjmZy", function(module, exports) {

$parcel$export(module.exports, "ChartServiceImpl", () => $e0f1a05ddd8b7668$export$3c5f23b4fd325ec1);

var $2v1vl = parcelRequire("2v1vl");

var $59teg = parcelRequire("59teg");

var $7U0KX = parcelRequire("7U0KX");

var $LBO4U = parcelRequire("LBO4U");

var $f2MYg = parcelRequire("f2MYg");

var $8ght1 = parcelRequire("8ght1");

var $fXdhi = parcelRequire("fXdhi");
let $e0f1a05ddd8b7668$export$3c5f23b4fd325ec1 = (()=>{
    let _classDecorators = [
        (0, $8ght1.Injectable)({
            requires: [
                (0, $LBO4U.$AssetsResolver),
                (0, $LBO4U.$Gateway),
                (0, $LBO4U.$CoreDataService)
            ],
            implements: (0, $LBO4U.$ChartService)
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var ChartServiceImpl = class {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            (0, $2v1vl.__esDecorate)(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            ChartServiceImpl = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            (0, $2v1vl.__runInitializers)(_classThis, _classExtraInitializers);
        }
        resolver;
        gateway;
        core;
        #songIndex = null;
        constructor(resolver, gateway, core){
            this.resolver = resolver;
            this.gateway = gateway;
            this.core = core;
        }
        getSongData() {
            return this.core.getChartData();
        }
        async getSongIndex() {
            return this.#songIndex ??= await this.#initSongIndex();
        }
        async getStatistics() {
            const songs = await this.getSongData();
            const statistics = (0, $fXdhi.d).reduce((map, difficulty)=>{
                map[difficulty] = {
                    count: 0,
                    notes: 0,
                    deleted: {
                        count: 0,
                        notes: 0
                    }
                };
                return map;
            }, {});
            let maximumConstant = -Infinity, minimumConstant = Infinity;
            const levels = new Map();
            const addChart = (chart, stat)=>{
                stat.count++;
                stat.notes += chart.note;
            };
            for (const song of songs)for (const chart of song.charts){
                const { level: level, plus: plus } = chart;
                const stat = statistics[chart.difficulty];
                if (song.version.deleted) {
                    addChart(chart, stat.deleted);
                    continue;
                }
                levels.set(level, (levels.get(level) ?? new Set()).add(!!plus));
                addChart(chart, stat);
                maximumConstant = Math.max(maximumConstant, chart.constant);
                minimumConstant = Math.min(minimumConstant, chart.constant);
            }
            const packs = [
                ...new Set(songs.map((s)=>s.pack))
            ];
            const archives = packs.filter((p)=>p.startsWith("Extend Archive"));
            const extend = packs.filter((p)=>p.startsWith("World Extend"));
            const basePacks = [
                "Arcaea"
            ];
            const freePacks = [
                ...basePacks,
                ...archives,
                ...extend
            ].sort();
            return {
                difficulties: statistics,
                ratings: [
                    ...levels
                ].flatMap(([level, plusSet])=>[
                        ...plusSet
                    ].map((plus)=>({
                            level: level,
                            plus: plus
                        }))).sort((0, $59teg.compareRating)),
                maximumConstant: maximumConstant,
                minimumConstant: minimumConstant,
                freePacks: freePacks,
                basePacks: basePacks
            };
        }
        async searchChart(searchText) {
            if (!searchText) return [];
            const songs = await this.getSongData();
            const matches = [];
            for (const song of songs)for (const chart of song.charts)candidateMatch: for (const candidate of [
                song.name,
                chart.id,
                chart.override?.name ?? "",
                ...song.alias
            ]){
                const match = (0, $7U0KX.searchMatch)(searchText, candidate);
                if (match != null) {
                    matches.push({
                        song: song,
                        bpm: this.getBPM(chart, song),
                        constant: chart.constant,
                        cover: this.getCover(chart, song),
                        difficulty: chart.difficulty,
                        sort: match,
                        chart: chart,
                        title: this.getName(chart, song)
                    });
                    break candidateMatch;
                }
            }
            return matches.sort((a, b)=>{
                if (a.sort !== b.sort) return a.sort - b.sort;
                return (0, $fXdhi.d).indexOf(b.difficulty) - (0, $fXdhi.d).indexOf(a.difficulty);
            });
        }
        async queryChartsByConstant(min, max) {
            const songs = await this.getSongData();
            const min10 = Math.round(min * 10);
            const max10 = Math.round(max * 10);
            const items = songs.flatMap((s)=>s.charts.map((c)=>({
                        song: s,
                        chart: c
                    }))).sort((a, b)=>a.chart.constant - b.chart.constant).filter((x)=>{
                const c = Math.round(x.chart.constant * 10);
                return min10 <= c && c <= max10;
            });
            return items.map((item)=>({
                    song: item.song,
                    bpm: this.getBPM(item.chart, item.song),
                    chart: item.chart,
                    constant: item.chart.constant,
                    cover: this.getCover(item.chart, item.song),
                    difficulty: item.chart.difficulty,
                    sort: 0,
                    title: this.getName(item.chart, item.song)
                }));
        }
        async roll(min, max) {
            const results = await this.queryChartsByConstant(min, max);
            if (!results.length) return null;
            return results.at(Math.floor(Math.random() * results.length)) ?? null;
        }
        getName(chart, song) {
            return chart.override?.name ?? song.name;
        }
        getBPM(chart, song) {
            return chart.override?.bpm ?? song.bpm;
        }
        getCover(chart, song) {
            return this.gateway.proxy(this.resolver.resolveCover(chart, song, false)).toString();
        }
        async #initSongIndex() {
            const songs = await this.getSongData();
            return (0, $f2MYg.indexBy)(songs, (s)=>s.id);
        }
    };
    return ChartServiceImpl = _classThis;
})();

});
parcelRegister("59teg", function(module, exports) {

$parcel$export(module.exports, "difficultyIndexes", () => $3c04774bae40b5d4$export$d873ff6a1db680e9);
$parcel$export(module.exports, "formatRating", () => $3c04774bae40b5d4$export$6cd762d00c0ff296);
$parcel$export(module.exports, "parseRating", () => $3c04774bae40b5d4$export$6cb03bc901b3fff5);
$parcel$export(module.exports, "compareRating", () => $3c04774bae40b5d4$export$1a05065c37a1b915);
$parcel$export(module.exports, "Grade", () => $3c04774bae40b5d4$export$ef5bc7f15dd14743);
$parcel$export(module.exports, "ClearRank", () => $3c04774bae40b5d4$export$27c979ae2d515816);
$parcel$export(module.exports, "Difficulty", () => (parcelRequire("542GE")).D);
$parcel$export(module.exports, "Side", () => (parcelRequire("542GE")).S);

var $542GE = parcelRequire("542GE");
const $3c04774bae40b5d4$export$d873ff6a1db680e9 = {
    [(0, $542GE.D).Past]: 0,
    [(0, $542GE.D).Present]: 1,
    [(0, $542GE.D).Future]: 2,
    [(0, $542GE.D).Beyond]: 3,
    [(0, $542GE.D).Eternal]: 4
};
const $3c04774bae40b5d4$export$6cd762d00c0ff296 = (rating)=>`${rating.level}${rating.plus ? "+" : ""}`;
const $3c04774bae40b5d4$export$6cb03bc901b3fff5 = (text)=>({
        level: parseInt(text),
        plus: text.includes("+")
    });
const $3c04774bae40b5d4$export$1a05065c37a1b915 = (a, b)=>{
    if (a.level !== b.level) return a.level - b.level;
    return +!!a.plus - +!!b.plus;
};
var $3c04774bae40b5d4$export$ef5bc7f15dd14743;
(function(Grade) {
    Grade["EXPlus"] = "EX+";
    Grade["EX"] = "EX";
    Grade["AA"] = "AA";
    Grade["A"] = "A";
    Grade["B"] = "B";
    Grade["C"] = "C";
    Grade["D"] = "D";
})($3c04774bae40b5d4$export$ef5bc7f15dd14743 || ($3c04774bae40b5d4$export$ef5bc7f15dd14743 = {}));
var $3c04774bae40b5d4$export$27c979ae2d515816;
(function(ClearRank) {
    ClearRank["Maximum"] = "Max";
    ClearRank["PureMemory"] = "PM";
    ClearRank["FullRecall"] = "FR";
    ClearRank["EasyClear"] = "EC";
    ClearRank["NormalClear"] = "NC";
    ClearRank["HardClear"] = "HC";
    ClearRank["TrackLost"] = "TL";
})($3c04774bae40b5d4$export$27c979ae2d515816 || ($3c04774bae40b5d4$export$27c979ae2d515816 = {}));

});
parcelRegister("542GE", function(module, exports) {

$parcel$export(module.exports, "S", () => $3aff690877096699$export$25ce5a424b770e84);
$parcel$export(module.exports, "R", () => $3aff690877096699$export$db202ddc8be9136);
$parcel$export(module.exports, "D", () => $3aff690877096699$export$96f57966bedc81b4);
var $3aff690877096699$export$25ce5a424b770e84, $3aff690877096699$export$db202ddc8be9136, $3aff690877096699$export$96f57966bedc81b4, $3aff690877096699$export$2329c99376c9d0a4, $3aff690877096699$export$e7094788287c5e9b, $3aff690877096699$export$3a1a48c8f6ef640e, $3aff690877096699$export$d66501df72047452, $3aff690877096699$export$db3b6bfb95261072, $3aff690877096699$export$4368d992c4eafac0, $3aff690877096699$export$407448d2b89b1813, $3aff690877096699$export$8b22cf2602fb60ce, $3aff690877096699$export$ef35774e6d314e91;
!function(n) {
    n[n.Light = 0] = "Light", n[n.Conflict = 1] = "Conflict", n[n.Colorless = 2] = "Colorless", n[n.Lephon = 3] = "Lephon";
}($3aff690877096699$export$25ce5a424b770e84 || ($3aff690877096699$export$25ce5a424b770e84 = {})), function(n) {
    n[n.Past = 0] = "Past", n[n.Present = 1] = "Present", n[n.Future = 2] = "Future", n[n.Beyond = 3] = "Beyond", n[n.Eternal = 4] = "Eternal";
}($3aff690877096699$export$db202ddc8be9136 || ($3aff690877096699$export$db202ddc8be9136 = {})), function(n) {
    n.Past = "pst", n.Present = "prs", n.Future = "ftr", n.Beyond = "byd", n.Eternal = "etr";
}($3aff690877096699$export$96f57966bedc81b4 || ($3aff690877096699$export$96f57966bedc81b4 = {})), function(n) {
    n.EXPlus = "EX+", n.EX = "EX", n.AA = "AA", n.A = "A", n.B = "B", n.C = "C", n.D = "D";
}($3aff690877096699$export$2329c99376c9d0a4 || ($3aff690877096699$export$2329c99376c9d0a4 = {})), function(n) {
    n.Maximum = "Max", n.PureMemory = "PM", n.FullRecall = "FR", n.EasyClear = "EC", n.NormalClear = "NC", n.HardClear = "HC", n.TrackLost = "TL";
}($3aff690877096699$export$e7094788287c5e9b || ($3aff690877096699$export$e7094788287c5e9b = {})), function(n) {
    n[n.Legacy0 = 0] = "Legacy0", n[n.Legacy1 = 1] = "Legacy1", n[n.Normal = 2] = "Normal";
}($3aff690877096699$export$3a1a48c8f6ef640e || ($3aff690877096699$export$3a1a48c8f6ef640e = {})), function(n) {
    n[n.$100 = 1.1] = "$100", n[n.$250 = 1.25] = "$250", n[n.$500 = 1.5] = "$500";
}($3aff690877096699$export$d66501df72047452 || ($3aff690877096699$export$d66501df72047452 = {})), function(n) {
    n[n.x2 = 2] = "x2", n[n.x4 = 4] = "x4", n[n.x6 = 6] = "x6";
}($3aff690877096699$export$db3b6bfb95261072 || ($3aff690877096699$export$db3b6bfb95261072 = {})), function(n) {
    n[n.OneMonth = 1.2] = "OneMonth", n[n.TwoMonth = 1.25] = "TwoMonth", n[n.ThreeMonth = 1.3] = "ThreeMonth";
}($3aff690877096699$export$4368d992c4eafac0 || ($3aff690877096699$export$4368d992c4eafac0 = {})), function(n) {
    n.Initial = "", n.Awaken = "u", n.Lost = "l";
}($3aff690877096699$export$407448d2b89b1813 || ($3aff690877096699$export$407448d2b89b1813 = {})), function(n) {
    n[n.Icon = 0] = "Icon", n[n.Full = 1] = "Full";
}($3aff690877096699$export$8b22cf2602fb60ce || ($3aff690877096699$export$8b22cf2602fb60ce = {})), function(n) {
    n.Course = "course", n.ArcaeaOnline = "aol";
}($3aff690877096699$export$ef35774e6d314e91 || ($3aff690877096699$export$ef35774e6d314e91 = {}));

});


parcelRegister("7U0KX", function(module, exports) {

$parcel$export(module.exports, "searchMatch", () => $5c0e598fa651811d$export$776cc6456d0d4832);
$parcel$export(module.exports, "trimSlash", () => $5c0e598fa651811d$export$99a7cc0443edb67);
$parcel$export(module.exports, "pad2", () => $5c0e598fa651811d$export$9decc9dc70e2c76f);
$parcel$export(module.exports, "formatDateTime", () => $5c0e598fa651811d$export$8b492ed8828f789c);
$parcel$export(module.exports, "formatTime", () => $5c0e598fa651811d$export$3203edd9e5edd663);
$parcel$export(module.exports, "randomString", () => $5c0e598fa651811d$export$7fa8378418b4411e);
/**
 * 搜素匹配，返回一个匹配系数
 */ const $5c0e598fa651811d$export$776cc6456d0d4832 = (searchText, candidate)=>{
    if (searchText === candidate) return 0;
    if (searchText.toUpperCase() === $5c0e598fa651811d$export$2bcb785951133fe5(candidate).toUpperCase()) return 0.5;
    const index = candidate.toLowerCase().indexOf(searchText.toLowerCase());
    if (index === -1) return null;
    return 1 + index + Math.log(candidate.length);
};
const $5c0e598fa651811d$export$99a7cc0443edb67 = (str)=>{
    let i = str.length - 1;
    for(let char = str[i]; char === "/";){
        i--;
        char = str[i];
    }
    return str.slice(0, i);
};
const $5c0e598fa651811d$export$9decc9dc70e2c76f = (n)=>`${n}`.padStart(2, "0");
const $5c0e598fa651811d$export$2bcb785951133fe5 = (s)=>s.split(/\s|[\.\-\[\]]/).map((part)=>part.trim().at(0)).filter((c)=>!!c).join("");
const $5c0e598fa651811d$export$8b492ed8828f789c = (date)=>`${date.getFullYear()}-${$5c0e598fa651811d$export$9decc9dc70e2c76f(date.getMonth() + 1)}-${$5c0e598fa651811d$export$9decc9dc70e2c76f(date.getDate())} ` + $5c0e598fa651811d$export$3203edd9e5edd663(date);
const $5c0e598fa651811d$export$3203edd9e5edd663 = (date)=>`${$5c0e598fa651811d$export$9decc9dc70e2c76f(date.getHours())}:${$5c0e598fa651811d$export$9decc9dc70e2c76f(date.getMinutes())}:${$5c0e598fa651811d$export$9decc9dc70e2c76f(date.getSeconds())}.${date.getMilliseconds().toString().padStart(3, "0")}`;
const $5c0e598fa651811d$var$upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const $5c0e598fa651811d$var$charset = $5c0e598fa651811d$var$upper + $5c0e598fa651811d$var$upper.toLowerCase() + "0123456789";
const $5c0e598fa651811d$export$7fa8378418b4411e = (length)=>Array.from({
        length: length
    }, ()=>$5c0e598fa651811d$var$charset[Math.floor(Math.random() * $5c0e598fa651811d$var$charset.length)]);

});

parcelRegister("f2MYg", function(module, exports) {

$parcel$export(module.exports, "groupBy", () => $af3d078a97a32ada$export$3f063810d7bf01bd);
$parcel$export(module.exports, "indexBy", () => $af3d078a97a32ada$export$e620e98009814b79);
$parcel$export(module.exports, "mapProps", () => $af3d078a97a32ada$export$818745deef20e20);
$parcel$export(module.exports, "apply", () => $af3d078a97a32ada$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "add", () => $af3d078a97a32ada$export$e16d8520af44a096);

var $dAkPh = parcelRequire("dAkPh");
function $af3d078a97a32ada$export$3f063810d7bf01bd(arr, selector) {
    return arr.reduce((index, item)=>{
        (index[selector(item)] ??= []).push(item);
        return index;
    }, {});
}
function $af3d078a97a32ada$export$e620e98009814b79(arr, selector) {
    return arr.reduce((index, item)=>{
        index[selector(item)] = item;
        return index;
    }, {});
}
function $af3d078a97a32ada$export$818745deef20e20(obj, selector) {
    // @ts-expect-error cannot infer obj key as K
    return Object.fromEntries(Object.entries(obj).map(([key, value])=>{
        // @ts-expect-error cannot infer type of value
        return [
            key,
            selector(value)
        ];
    }));
}
const $af3d078a97a32ada$export$5635d7ef4b8fee1c = (a, b, op)=>{
    const aa = op.accepts(a), ba = op.accepts(b);
    const fail = ()=>{
        throw new Error(`cannot operate on ${a} and ${b}`);
    };
    if (aa && ba) // @ts-expect-error not type safe
    return op.apply(a, b);
    if (aa !== ba || typeof a !== typeof b) return fail();
    if (Array.isArray(a)) {
        if (!Array.isArray(b)) return fail();
        if (a.length !== b.length) return fail();
        // @ts-expect-error not type safe
        return a.map((el, i)=>$af3d078a97a32ada$export$5635d7ef4b8fee1c(el, b[i], op));
    }
    if ((0, $dAkPh.isObject)(a) && (0, $dAkPh.isObject)(b)) return Object.fromEntries([
        ...new Set([
            ...Reflect.ownKeys(a),
            ...Reflect.ownKeys(b)
        ].map((key)=>{
            const va = Reflect.get(a, key), vb = Reflect.get(b, key);
            return [
                key,
                $af3d078a97a32ada$export$5635d7ef4b8fee1c(va, vb, op)
            ];
        }))
    ]);
    return fail();
};
const $af3d078a97a32ada$export$e16d8520af44a096 = {
    accepts (value) {
        return (0, $dAkPh.isNumber)(value);
    },
    apply (a, b) {
        return a + b;
    }
};

});
parcelRegister("dAkPh", function(module, exports) {

$parcel$export(module.exports, "clone", () => $9e3ecacb5a3c909b$export$9cd59f9826255e47);
$parcel$export(module.exports, "once", () => $9e3ecacb5a3c909b$export$d2de3aaeafa91619);
$parcel$export(module.exports, "isNumber", () => $9e3ecacb5a3c909b$export$7e4aa119212bc614);
$parcel$export(module.exports, "isString", () => $9e3ecacb5a3c909b$export$844ec244b1367d54);
$parcel$export(module.exports, "isObject", () => $9e3ecacb5a3c909b$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isEnumValueOf", () => $9e3ecacb5a3c909b$export$7893b39d972982e0);
$parcel$export(module.exports, "shape", () => $9e3ecacb5a3c909b$export$98bada23690e67eb);
$parcel$export(module.exports, "nocheck", () => $9e3ecacb5a3c909b$export$72dc9fa7039f251);
$parcel$export(module.exports, "jsonModule", () => $9e3ecacb5a3c909b$export$249c5ce80fc1e086);
$parcel$export(module.exports, "esModule", () => $9e3ecacb5a3c909b$export$4a3506a8bc7a08df);
const $9e3ecacb5a3c909b$export$9cd59f9826255e47 = (json)=>JSON.parse(JSON.stringify(json));
const $9e3ecacb5a3c909b$export$d2de3aaeafa91619 = (factory)=>{
    let value = null;
    return ()=>value ??= factory();
};
const $9e3ecacb5a3c909b$export$7e4aa119212bc614 = (value)=>typeof value === "number";
const $9e3ecacb5a3c909b$export$844ec244b1367d54 = (value)=>typeof value === "string";
const $9e3ecacb5a3c909b$export$a6cdc56e425d0d0a = (value)=>typeof value === "object" && value != null;
const $9e3ecacb5a3c909b$export$7893b39d972982e0 = (enumObject, value)=>Object.values(enumObject).some((e)=>e === value) && isNaN(+Reflect.get(enumObject, value));
function $9e3ecacb5a3c909b$export$98bada23690e67eb(schema) {
    return (value)=>$9e3ecacb5a3c909b$export$a6cdc56e425d0d0a(value) && Object.entries(value).every(([pk, pv])=>{
            if (!(pk in schema)) return true;
            const validator = Reflect.get(schema, pk);
            if (typeof validator !== "function") return false;
            return !!validator(pv);
        });
}
const $9e3ecacb5a3c909b$export$72dc9fa7039f251 = (value)=>true;
const $9e3ecacb5a3c909b$export$249c5ce80fc1e086 = (imports)=>// @ts-expect-error parcel json module is using common js and module.exports = JSON.parse(...)
    imports;
const $9e3ecacb5a3c909b$export$4a3506a8bc7a08df = $9e3ecacb5a3c909b$export$249c5ce80fc1e086;

});


parcelRegister("fXdhi", function(module, exports) {

$parcel$export(module.exports, "d", () => $b9d6aa73a652e2eb$export$4368d992c4eafac0);

var $542GE = parcelRequire("542GE");
const $b9d6aa73a652e2eb$export$43caf9889c228507 = [
    (0, $542GE.R).Past,
    (0, $542GE.R).Present,
    (0, $542GE.R).Future,
    (0, $542GE.R).Beyond,
    (0, $542GE.R).Eternal
], $b9d6aa73a652e2eb$export$4368d992c4eafac0 = [
    (0, $542GE.D).Past,
    (0, $542GE.D).Present,
    (0, $542GE.D).Future,
    (0, $542GE.D).Beyond,
    (0, $542GE.D).Eternal
];

});


parcelRegister("9VeuO", function(module, exports) {

$parcel$export(module.exports, "MusicPlayServiceImpl", () => $7394ae8b3f67a907$export$bb76731e99a5d634);

var $2v1vl = parcelRequire("2v1vl");

var $8ght1 = parcelRequire("8ght1");

var $59teg = parcelRequire("59teg");

var $LBO4U = parcelRequire("LBO4U");

var $542GE = parcelRequire("542GE");
const $7394ae8b3f67a907$var$MAX_BASE_SCORE = 10000000;
const $7394ae8b3f67a907$var$EX_PLUS_SCORE = 9900000;
const $7394ae8b3f67a907$var$EX_SCORE = 9800000;
const $7394ae8b3f67a907$var$AA_SCORE = 9500000;
const $7394ae8b3f67a907$var$A_SCORE = 9200000;
const $7394ae8b3f67a907$var$B_SCORE = 8900000;
const $7394ae8b3f67a907$var$C_SCORE = 8600000;
const $7394ae8b3f67a907$var$EX_RATIO = 200000;
const $7394ae8b3f67a907$var$AA_RATIO = 300000;
// @ts-expect-error object entries type
const $7394ae8b3f67a907$var$GRADE_INDEX = Object.fromEntries(Object.values((0, $59teg.Grade)).map((grade, i)=>[
        grade,
        i
    ]));
let $7394ae8b3f67a907$export$bb76731e99a5d634 = (()=>{
    let _classDecorators = [
        (0, $8ght1.Injectable)({
            requires: [
                (0, $LBO4U.$Logger),
                (0, $LBO4U.$ChartService)
            ],
            implements: (0, $LBO4U.$MusicPlayService)
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var MusicPlayServiceImpl = class {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            (0, $2v1vl.__esDecorate)(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            MusicPlayServiceImpl = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            (0, $2v1vl.__runInitializers)(_classThis, _classExtraInitializers);
        }
        logger;
        chart;
        ex = $7394ae8b3f67a907$var$EX_SCORE;
        grades = Object.values((0, $59teg.Grade));
        maxBase = $7394ae8b3f67a907$var$MAX_BASE_SCORE;
        constructor(logger, chart){
            this.logger = logger;
            this.chart = chart;
        }
        async getStatistics() {
            const songs = await this.chart.getSongData();
            const stats = await this.chart.getStatistics();
            const constants = songs.filter((s)=>!s.version.deleted).flatMap((s)=>s.charts.map((c)=>c.constant));
            const maxs = [
                ...constants
            ].sort((a, b)=>b - a).slice(0, 30);
            const maxptt = maxs.concat(maxs.slice(0, 10)).reduce((sum, curr)=>sum + curr + 2, 0) / 40;
            return {
                maximumPotential: maxptt,
                maximumSinglePotential: stats.maximumConstant + 2
            };
        }
        inferNoteResult(chart, perfect, far, lost, score) {
            const { note: note } = chart;
            if (perfect != null && far != null && lost != null) return {
                pure: note - far - lost,
                perfect: perfect,
                far: far,
                lost: lost
            };
            if (score != null && far != null && lost != null) {
                const pure = note - far - lost;
                const noPerfectScore = this.computeScore(chart, {
                    pure: pure,
                    perfect: 0,
                    far: far,
                    lost: lost
                });
                return {
                    pure: pure,
                    perfect: score - noPerfectScore,
                    far: far,
                    lost: lost
                };
            }
            if (score != null) {
                if (score >= $7394ae8b3f67a907$var$MAX_BASE_SCORE) // 认为是PM
                return {
                    pure: note,
                    perfect: score - $7394ae8b3f67a907$var$MAX_BASE_SCORE,
                    far: 0,
                    lost: 0
                };
                // 不考虑1far得分低于大P数，性1far也可以推断
                const oneFarScore = this.computeScore(chart, {
                    pure: note - 1,
                    perfect: 0,
                    far: 1,
                    lost: 0
                });
                if (score >= oneFarScore) return {
                    pure: note - 1,
                    perfect: score - oneFarScore,
                    far: 1,
                    lost: 0
                };
            }
            // 全连根据分数算far数量懒得写了，得多加参数
            return null;
        }
        computeScore(chart, playResult) {
            const { perfect: perfect, far: far, lost: lost } = playResult;
            return Math.floor($7394ae8b3f67a907$var$MAX_BASE_SCORE * (1 - (far / 2 + lost) / chart.note)) + perfect;
        }
        computeGrade(score) {
            switch(true){
                case score >= $7394ae8b3f67a907$var$EX_PLUS_SCORE:
                    return (0, $59teg.Grade).EXPlus;
                case score >= $7394ae8b3f67a907$var$EX_SCORE:
                    return (0, $59teg.Grade).EX;
                case score >= $7394ae8b3f67a907$var$AA_SCORE:
                    return (0, $59teg.Grade).AA;
                case score >= $7394ae8b3f67a907$var$A_SCORE:
                    return (0, $59teg.Grade).A;
                case score >= $7394ae8b3f67a907$var$B_SCORE:
                    return (0, $59teg.Grade).B;
                case score >= $7394ae8b3f67a907$var$C_SCORE:
                    return (0, $59teg.Grade).C;
                default:
                    return (0, $59teg.Grade).D;
            }
        }
        computeClearRank(noteResult, chart, clear) {
            const { far: far, lost: lost, perfect: perfect } = noteResult;
            const { note: note } = chart;
            if (!lost) {
                if (!far) {
                    if (perfect === note) // 您
                    return (0, $59teg.ClearRank).Maximum;
                    return (0, $59teg.ClearRank).PureMemory;
                }
                // 即使全连也可能因为far太多被特殊角色在最后一个note给TL……
                // 不知道用啥角色的情况不考虑了，但是选了Track Lost就算他TL
                if (clear !== (0, $59teg.ClearRank).TrackLost) return (0, $59teg.ClearRank).FullRecall;
            }
            return clear;
        }
        computePotentialModifier(score) {
            if (score >= $7394ae8b3f67a907$var$MAX_BASE_SCORE) // 不考虑非PM的超过1000W分，目前没有这样的谱
            return 2;
            if (score >= $7394ae8b3f67a907$var$EX_SCORE) return (score - $7394ae8b3f67a907$var$EX_SCORE) / $7394ae8b3f67a907$var$EX_RATIO + 1;
            return (score - $7394ae8b3f67a907$var$EX_SCORE) / $7394ae8b3f67a907$var$AA_RATIO + 1;
        }
        computePotential(score, chart) {
            const { constant: constant } = chart;
            const modifier = this.computePotentialModifier(score);
            return Math.max(0, constant + modifier);
        }
        computeScoreResult(score, chart) {
            return {
                grade: this.computeGrade(score),
                chartId: chart.id,
                score: score,
                potential: this.computePotential(score, chart)
            };
        }
        computeRankingLoseScore(play, chart) {
            if (![
                (0, $542GE.D).Future,
                (0, $542GE.D).Beyond,
                (0, $542GE.D).Eternal
            ].includes(chart.difficulty)) return 0;
            const score = this.computeScore(chart, play);
            const perfectLosePoint = Math.max(0, Math.min(0.995 - play.perfect / chart.note, 0.095));
            const scoreLosePoint = 28.5 * Math.max(0, Math.min(1 - score / $7394ae8b3f67a907$var$MAX_BASE_SCORE, 0.01));
            return -100 * (chart.constant * (perfectLosePoint + scoreLosePoint));
        }
        computePMConstant(potential, overflow) {
            const target = potential - 2;
            const gapFactor = target >= 8 ? 10 : 2;
            return (overflow ? Math.ceil : Math.floor)(target * gapFactor) / gapFactor;
        }
        inverseScore(potential, constant) {
            const modifier = potential - constant;
            const rawScore = modifier < 1 ? modifier * $7394ae8b3f67a907$var$AA_RATIO + $7394ae8b3f67a907$var$AA_SCORE : (modifier - 1) * $7394ae8b3f67a907$var$EX_RATIO + $7394ae8b3f67a907$var$EX_SCORE;
            return Math.round(rawScore);
        }
        inverseConstant(potential, score, raw) {
            const modifier = this.computePotentialModifier(score);
            this.logger.info(`\u{5206}\u{6570} => \u{4FEE}\u{6B63}\u{503C}\u{FF08}\u{5355}\u{66F2}\u{6F5C}\u{529B}\u{503C}-\u{5B9A}\u{6570}\u{FF09}`, score, modifier);
            const rawConstant = potential - modifier;
            this.logger.info(`\u{516C}\u{5F0F}\u{63A8}\u{7B97}\u{5B9A}\u{6570}`, rawConstant);
            if (raw) return rawConstant;
            return Math.round(rawConstant * 10) / 10;
        }
        computeFar(score, note, overflow) {
            const count = ($7394ae8b3f67a907$var$MAX_BASE_SCORE - score) * note * 2 / $7394ae8b3f67a907$var$MAX_BASE_SCORE;
            return (overflow ? Math.floor : Math.ceil)(count);
        }
        compareGrade(a, b) {
            return $7394ae8b3f67a907$var$GRADE_INDEX[a] - $7394ae8b3f67a907$var$GRADE_INDEX[b];
        }
        getPotentialRating(potential) {
            if (potential < 0) return -1;
            return [
                3.5,
                7.0,
                10.0,
                11.0,
                12.0,
                12.5,
                13.0,
                Infinity
            ].findIndex((bound)=>potential < bound);
        }
        mapClearType(clearType, shinyPerfectCount, chart) {
            if (shinyPerfectCount === chart.note) return (0, $59teg.ClearRank).Maximum;
            switch(clearType){
                case 0:
                    return (0, $59teg.ClearRank).TrackLost;
                case 1:
                    return (0, $59teg.ClearRank).NormalClear;
                case 2:
                    return (0, $59teg.ClearRank).FullRecall;
                case 3:
                    return (0, $59teg.ClearRank).PureMemory;
                case 4:
                    return (0, $59teg.ClearRank).EasyClear;
                case 5:
                    return (0, $59teg.ClearRank).HardClear;
            }
            throw new Error(`\u{672A}\u{77E5}clear_type: ${clearType}`);
        }
        mapDifficulty(d) {
            return (0, $59teg.difficultyIndexes)[d];
        }
    };
    return MusicPlayServiceImpl = _classThis;
})();

});

parcelRegister("bKGjK", function(module, exports) {

$parcel$export(module.exports, "ProfileServiceImpl", () => $88e4d0f35fdf9a5b$export$c1de537eae1c60b2);

var $2v1vl = parcelRequire("2v1vl");

var $59teg = parcelRequire("59teg");

var $6X20m = parcelRequire("6X20m");

var $6vc4O = parcelRequire("6vc4O");

var $2Svg7 = parcelRequire("2Svg7");

var $LBO4U = parcelRequire("LBO4U");

var $8ght1 = parcelRequire("8ght1");

var $f2MYg = parcelRequire("f2MYg");

var $gkZs7 = parcelRequire("gkZs7");

var $lxieH = parcelRequire("lxieH");

var $d85fI = parcelRequire("d85fI");

var $dAkPh = parcelRequire("dAkPh");

var $fXdhi = parcelRequire("fXdhi");

var $bESPZ = parcelRequire("bESPZ");
const $88e4d0f35fdf9a5b$var$KEY_CURRENT_USERNAME = "CURRENT_USERNAME";
const $88e4d0f35fdf9a5b$var$isValidProfileV1 = (input)=>{
    const value = input;
    return value != null && typeof value === "object" && value.version === 1 && typeof value.username === "string" && typeof value.potential === "string" && typeof value.best === "object" && (value.characters == null || Array.isArray(value.characters));
};
const $88e4d0f35fdf9a5b$var$isValidProfileV2 = (input)=>{
    const value = input;
    return value != null && typeof value === "object" && value.version === 2 && typeof value.username === "string" && typeof value.potential === "string" && typeof value.best === "object" && (value.characters == null || Array.isArray(value.characters));
};



let $88e4d0f35fdf9a5b$export$c1de537eae1c60b2 = (()=>{
    let _classDecorators = [
        (0, $8ght1.Injectable)({
            requires: [
                (0, $LBO4U.$Database),
                (0, $LBO4U.$MusicPlayService),
                (0, $LBO4U.$ChartService)
            ],
            implements: (0, $LBO4U.$ProfileService)
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var ProfileServiceImpl = class {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            (0, $2v1vl.__esDecorate)(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            ProfileServiceImpl = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            (0, $2v1vl.__runInitializers)(_classThis, _classExtraInitializers);
        }
        database;
        musicPlay;
        chartService;
        #currentUsername = this.#getInitCurrentUsername();
        #SQL = null;
        constructor(database, musicPlay, chartService){
            this.database = database;
            this.musicPlay = musicPlay;
            this.chartService = chartService;
        }
        async checkMigration() {
            const legacyProfiles = this.#getLegacyProfileListSync();
            if (!legacyProfiles.length) return null;
            return async ()=>{
                const upgradedProfiles = await Promise.all(legacyProfiles.map(async (profile)=>{
                    if ($88e4d0f35fdf9a5b$var$isValidProfileV1(profile)) return this.#upgradeV1(profile);
                    return profile;
                }));
                await this.syncProfiles(upgradedProfiles);
                this.#removeLegacyProfilesSync(upgradedProfiles.map((p)=>p.username));
            };
        }
        formatPotential(potential) {
            const maxDivider = 600000;
            const rating = Math.round(potential * maxDivider);
            return (rating / maxDivider).toFixed(2);
        }
        async getProfile() {
            const username = this.#currentUsername ?? await this.#getPossibleOnlyUsername();
            if (!username) return null;
            if (username !== this.#currentUsername) await this.useProfile(username);
            const profile = await this.#getProfileAsync(username);
            if (!profile) sessionStorage.removeItem($88e4d0f35fdf9a5b$var$KEY_CURRENT_USERNAME);
            return profile;
        }
        async createOrUpdateProfile(username, potential) {
            const profile = await this.#getProfileAsync(username) ?? this.createEmptyProfile(username);
            profile.potential = potential.toFixed(2);
            profile.username = username;
            await this.#saveProfile(profile);
        }
        async getProfileList() {
            const usernames = await (0, $d85fI.requestToPromise)((await this.#store()).getAllKeys());
            return usernames?.filter((0, $dAkPh.isString)) ?? [];
        }
        async syncProfiles(data) {
            for (const profile of data)this.#saveProfile(profile);
        }
        async importBest(best) {
            const profile = (0, $dAkPh.clone)(await this.getProfile());
            if (!profile) throw new Error("No current profile.");
            Object.assign(profile.best, best);
            await this.#saveProfile(profile);
        }
        async importProfile(file) {
            const content = await (0, $6vc4O.readFile)(file);
            try {
                const json = JSON.parse(content);
                const profile = $88e4d0f35fdf9a5b$var$isValidProfileV1(json) ? await this.#upgradeV1(json) : $88e4d0f35fdf9a5b$var$isValidProfileV2(json) ? json : null;
                if (!profile) {
                    (0, $2Svg7.alert)(`\u{5B58}\u{6863}\u{683C}\u{5F0F}\u{9519}\u{8BEF}`);
                    return;
                }
                const username = profile.username;
                const oldProfile = await this.#getProfileAsync(username);
                if (oldProfile != null) {
                    if (!await (0, $2Svg7.confirm)("\u5DF2\u5B58\u5728\u540C\u540D\u5B58\u6863\uFF0C\u662F\u5426\u8986\u76D6\uFF1F")) return;
                }
                await this.#saveProfile(profile);
                (0, $2Svg7.alert)("\u5BFC\u5165\u6210\u529F");
            } catch (error) {
                (0, $2Svg7.alert)(`\u{5BC4}\u{FF01}${error}`);
            }
        }
        async exportProfile(profile) {
            const url = URL.createObjectURL(new Blob([
                JSON.stringify(profile)
            ], {
                type: "application/json"
            }));
            (0, $6X20m.download)(url, `profile_${profile.username}.json`);
        }
        async addResult(playResult, replace) {
            const p = await this.getProfile();
            if (!p) {
                (0, $2Svg7.alert)("\u672A\u9009\u62E9\u5B58\u6863");
                return;
            }
            if (!replace) {
                const oldResult = p.best[playResult.chartId];
                if (oldResult) {
                    const { chart: chart } = (await this.chartService.searchChart(playResult.chartId))[0] ?? {};
                    if (chart) {
                        const getScore = (res)=>res.type === "score" ? res.score : this.musicPlay.computeScore(chart, res.result);
                        const oldScore = getScore(oldResult);
                        const newScore = getScore(playResult);
                        if (newScore <= oldScore && !await (0, $2Svg7.confirm)(`\u{5F53}\u{524D}\u{5206}\u{6570}\u{FF08}${newScore}\u{FF09}\u{672A}\u{8D85}\u{8FC7}\u{73B0}\u{6709}\u{5206}\u{6570}\u{FF08}${oldScore}\u{FF09}\u{FF0C}\u{662F}\u{5426}\u{66FF}\u{6362}\u{FF1F}`)) return;
                    }
                }
            }
            p.best[playResult.chartId] = playResult;
            await this.#saveProfile(p);
        }
        async useProfile(username) {
            this.#currentUsername = username;
            sessionStorage.setItem($88e4d0f35fdf9a5b$var$KEY_CURRENT_USERNAME, username);
        }
        async removeResult(chartId) {
            const p = await this.getProfile();
            if (!p) return;
            delete p.best[chartId];
            await this.#saveProfile(p);
        }
        async deleteProfile(username) {
            const store = await this.#store("readwrite");
            await (0, $d85fI.requestToPromise)(store.delete(username));
        }
        async b30(profile, options) {
            const songs = await this.chartService.getSongData();
            const charts = Object.fromEntries(songs.flatMap((s)=>s.charts.map((c)=>[
                        c.id,
                        {
                            chart: c,
                            song: s
                        }
                    ])));
            const playResults = Object.values(profile.best).map((r)=>{
                const { chart: chart, song: song } = charts[r.chartId];
                const { clear: clear } = r;
                if (r.type === "score") {
                    const { score: score } = r;
                    return {
                        chart: chart,
                        score: this.musicPlay.computeScoreResult(score, chart),
                        song: song,
                        clear: clear,
                        note: null,
                        no: 0,
                        date: r.date
                    };
                }
                return {
                    chart: chart,
                    song: song,
                    clear: clear,
                    no: 0,
                    note: r.result,
                    score: this.musicPlay.computeScoreResult(this.musicPlay.computeScore(chart, r.result), chart),
                    date: r.date
                };
            });
            let hasFilter = options && Object.values(options).some((v)=>!(0, $bESPZ.B)(v));
            const ordered = playResults.filter((item)=>{
                if (!options) return true;
                const { score: { grade: grade }, chart: chart, song: song, clear: clear } = item;
                const { packs: packs, difficulties: difficulties, rank: rank, constant: constant } = options;
                if (song.version.deleted) // TODO support version filter
                return false;
                if (packs) {
                    if (!packs.includes(song.pack)) return false;
                }
                if (rank) {
                    if (rank === (0, $59teg.ClearRank).PureMemory || rank === (0, $59teg.ClearRank).Maximum) {
                        const levels = [
                            (0, $59teg.ClearRank).PureMemory,
                            (0, $59teg.ClearRank).Maximum
                        ];
                        if (levels.indexOf(rank) > levels.indexOf(clear)) return false;
                    } else if (this.musicPlay.compareGrade(grade, rank) > 0) return false;
                }
                if (constant) {
                    if (chart.constant < constant.min || chart.constant > constant.max) return false;
                }
                if (difficulties) {
                    if (!difficulties.includes(chart.difficulty)) return false;
                }
                return true;
            }).sort((a, b)=>b.score.potential - a.score.potential).map((r, i)=>({
                    ...r,
                    no: i + 1
                }));
            const b30 = ordered.slice(0, 30);
            const ptt30 = b30.map((r)=>r.score.potential);
            const b30Sum = (0, $lxieH.sum)(ptt30);
            const b10Sum = (0, $lxieH.sum)(ptt30.slice(0, 10));
            const maxPotential = (b10Sum + b30Sum) / 40;
            const minPotential = b30Sum / 40;
            const potential = this.formatPotential(hasFilter ? maxPotential : +profile.potential);
            // 如果成绩少于10个，recent 10的平均值应当按照成绩个数取平均
            const r10Average = (+potential * 40 - b30Sum) / Math.min(playResults.length, 10);
            return {
                queryTime: Date.now(),
                username: profile.username,
                potential: potential,
                rating: this.musicPlay.getPotentialRating(+potential),
                b30: b30,
                b31_39: ordered.slice(30, 39),
                maxPotential: maxPotential,
                minPotential: minPotential,
                r10Average: r10Average,
                b30Average: b30Sum / ptt30.length
            };
        }
        async generateMaxProfile() {
            const songData = await this.chartService.getSongData();
            const stats = await this.musicPlay.getStatistics();
            const profile = this.createEmptyProfile("\uD83D\uDC7D");
            profile.potential = this.formatPotential(stats.maximumPotential);
            for (const song of songData)for (const chart of song.charts)profile.best[chart.id] = {
                chartId: chart.id,
                clear: (0, $59teg.ClearRank).Maximum,
                type: "note",
                result: {
                    far: 0,
                    lost: 0,
                    perfect: chart.note,
                    pure: chart.note
                }
            };
            return profile;
        }
        async importDB(file, profile, report) {
            report?.("\u6B63\u5728\u8BFB\u53D6\u6587\u4EF6");
            const bytes = await (0, $6vc4O.readBinary)(file);
            report?.("\u6B63\u5728\u52A0\u8F7D\u6A21\u5757");
            const SQL = this.#SQL ??= await this.#initSQLJS();
            report?.("\u6B63\u5728\u67E5\u8BE2\u6210\u7EE9");
            await (0, $gkZs7.delay)(300);
            const db = new SQL.Database(new Uint8Array(bytes));
            const [scoreQueryResult] = db.exec(`\
SELECT
scores.songId,
scores.songDifficulty,
scores.shinyPerfectCount,
scores.perfectCount,
scores.nearCount,
scores.missCount,
scores.date,
cleartypes.clearType 
FROM scores JOIN cleartypes
ON scores.songId = cleartypes.songId AND scores.songDifficulty = cleartypes.songDifficulty
`);
            report?.("\u6B63\u5728\u5BFC\u5165\u5B58\u6863");
            if (!scoreQueryResult) throw new Error(`\u{8BFB}\u{53D6}\u{6570}\u{636E}\u{5E93}\u{5931}\u{8D25}\u{FF1A}\u{65E0}\u{7ED3}\u{679C}\u{96C6}\u{3002}\u{53EF}\u{80FD}\u{539F}\u{56E0}\u{FF1A}\u{5BFC}\u{51FA}st3\u{524D}\u{672A}\u{540C}\u{6B65}\u{4E91}\u{7AEF}\u{5B58}\u{6863}\u{FF0C}\u{5B58}\u{6863}\u{5185}\u{65E0}\u{6570}\u{636E}\u{3002}`);
            const { columns: columns, values: values } = scoreQueryResult;
            const scores = values.map((row)=>row.reduce((st3Score, value, index)=>{
                    Reflect.set(st3Score, columns[index], value);
                    return st3Score;
                }, {}));
            const songIndex = await this.chartService.getSongIndex();
            const now = Date.now();
            const { best: best } = profile;
            const result = {
                count: 0,
                difficulties: (0, $f2MYg.mapProps)((0, $f2MYg.groupBy)((0, $fXdhi.d), (d)=>d), ()=>0),
                skipped: []
            };
            for (const score of scores){
                const { songId: songId, songDifficulty: songDifficulty, shinyPerfectCount: shinyPerfectCount, perfectCount: perfectCount, nearCount: nearCount, missCount: missCount, date: date, clearType: clearType } = score;
                const song = songIndex[songId];
                if (!song) {
                    result.skipped.push(`\u{672A}\u{77E5}songId\u{FF1A}${songId}`);
                    continue;
                }
                const chart = song.charts.find((c)=>c.difficulty === (0, $fXdhi.d)[songDifficulty]);
                if (!chart) {
                    result.skipped.push(`\u{66F2}\u{76EE}${song.name}\u{7684}${(0, $fXdhi.d)[songDifficulty]}\u{96BE}\u{5EA6}\u{8C31}\u{9762}\u{672A}\u{77E5}`);
                    continue;
                }
                const noteResult = {
                    perfect: shinyPerfectCount,
                    pure: perfectCount,
                    far: nearCount,
                    lost: missCount
                };
                best[chart.id] = {
                    type: "note",
                    result: noteResult,
                    chartId: chart.id,
                    clear: this.musicPlay.mapClearType(clearType, shinyPerfectCount, chart),
                    date: this.#normalizeDate(date, now)
                };
                result.difficulties[chart.difficulty]++;
                result.count++;
            }
            await this.#saveProfile({
                username: profile.username,
                best: best
            });
            return result;
        }
        async getProfileStatistics(profile, query) {
            const byRecords = (records)=>{
                let total = records.length, clear = 0, fr = 0, pm = 0, max = 0, rkls = 0, totalAccScore = 0, totalAccChartCount = 0, totalDetailed = 0, totalPerfect = 0, totalGreat = 0, totalNotes = 0, totalScore = 0, totalNoteResultNotes = 0;
                const arksNotComputedCharts = new Set(Object.keys(filteredCharts));
                for (const record of records){
                    const chart = charts[record.chartId];
                    const { note: note } = chart;
                    totalNotes += note;
                    let score = 0;
                    if (record.type === "note") {
                        const { result: result } = record;
                        const { perfect: perfect, pure: pure } = result;
                        totalDetailed++;
                        totalNoteResultNotes += note;
                        totalPerfect += perfect;
                        totalGreat += pure - perfect;
                        switch(record.clear){
                            // @ts-ignore
                            case (0, $59teg.ClearRank).Maximum:
                                max++;
                            // @ts-ignore
                            case (0, $59teg.ClearRank).PureMemory:
                                pm++;
                            // @ts-ignore
                            case (0, $59teg.ClearRank).FullRecall:
                                fr++;
                            case (0, $59teg.ClearRank).EasyClear:
                            case (0, $59teg.ClearRank).NormalClear:
                            case (0, $59teg.ClearRank).HardClear:
                                clear++;
                        }
                        score = this.musicPlay.computeScore(chart, result);
                        rkls += this.musicPlay.computeRankingLoseScore(record.result, chart);
                        arksNotComputedCharts.delete(record.chartId);
                    } else if (record.type === "score") score = record.score;
                    totalScore += score;
                    const accScore = Math.min(score, this.musicPlay.maxBase);
                    if (accScore > this.musicPlay.ex) {
                        totalAccScore += accScore;
                        totalAccChartCount++;
                    }
                }
                const frkls = rkls + (0, $lxieH.sum)([
                    ...arksNotComputedCharts
                ].map((chartId)=>{
                    const chart = charts[chartId];
                    return this.musicPlay.computeRankingLoseScore({
                        far: 0,
                        lost: chart.note,
                        pure: 0,
                        perfect: 0
                    }, chart);
                }));
                const acc = totalAccScore / totalAccChartCount / this.musicPlay.maxBase;
                const pacc = totalPerfect / totalNoteResultNotes;
                const rest = totalNotes + total * this.musicPlay.maxBase - totalScore;
                return {
                    total: total,
                    clear: clear,
                    pm: pm,
                    fr: fr,
                    max: max,
                    acc: acc,
                    detailed: totalDetailed,
                    perfect: totalPerfect,
                    great: totalGreat,
                    notes: totalNoteResultNotes,
                    pacc: pacc,
                    rkls: rkls,
                    frkls: frkls,
                    rest: rest
                };
            };
            const songs = await this.chartService.getSongData();
            const charts = (0, $f2MYg.indexBy)(songs.flatMap((song)=>song.charts), (chart)=>chart.id);
            const all = Object.values(profile.best);
            const filterChart = (chart)=>{
                if (!query) return true;
                const { rating: rating, difficulty: difficulty } = query;
                if (difficulty) {
                    if (chart.difficulty !== difficulty) return false;
                }
                if (rating) {
                    if (chart.level !== rating.level || !!chart.plus !== !!rating.plus) return false;
                }
                return true;
            };
            const filteredResults = all.filter((result)=>filterChart(charts[result.chartId]));
            const filteredCharts = Object.fromEntries(Object.entries(charts).filter(([, value])=>{
                return filterChart(value);
            }));
            return byRecords(filteredResults);
        }
        createEmptyProfile(username) {
            return {
                best: {},
                potential: "0",
                username: username,
                version: 2
            };
        }
        /**
         * @deprecated
         */ #getLegacyJSONSync(username) {
            try {
                return JSON.parse(localStorage.getItem(username));
            } catch  {
                return null;
            }
        }
        async #getProfileAsync(username) {
            const store = await this.#store();
            const profile = await (0, $d85fI.requestToPromise)(store.get(username));
            return profile;
        }
        async #upgradeV1(v1) {
            const indexed = await this.#getV1Map();
            return {
                ...v1,
                version: 2,
                best: Object.fromEntries(Object.entries(v1.best).map(([oldChartId, value])=>{
                    const chartId = indexed[oldChartId.toLowerCase()];
                    if (!chartId) throw new Error(`Cannot upgrade chartId: ${oldChartId}`);
                    return [
                        chartId,
                        {
                            ...value,
                            chartId: chartId
                        }
                    ];
                }))
            };
        }
        async #saveProfile(profile) {
            const key = profile.username;
            const original = await this.#getProfileAsync(key) ?? this.createEmptyProfile(key);
            const newProfile = Object.assign({}, original, profile);
            await this.#saveProfileDirectly(newProfile);
        }
        async #saveProfileDirectly(profile) {
            const store = await this.#store("readwrite");
            await (0, $d85fI.requestToPromise)(store.put(profile));
        }
        #getInitCurrentUsername() {
            const sessionUsername = sessionStorage.getItem($88e4d0f35fdf9a5b$var$KEY_CURRENT_USERNAME);
            if (sessionUsername) return sessionUsername;
            return null;
        }
        async #getPossibleOnlyUsername() {
            const profiles = await this.getProfileList();
            return profiles.length === 1 ? profiles[0] : null;
        }
        /**
         * @deprecated
         */ #getLegacyProfileListSync() {
            return Array.from({
                length: localStorage.length
            }, (_, i)=>localStorage.key(i)).map((key)=>this.#getLegacyJSONSync(key)).filter((profile)=>{
                return $88e4d0f35fdf9a5b$var$isValidProfileV1(profile) || $88e4d0f35fdf9a5b$var$isValidProfileV2(profile);
            });
        }
        /**
         * @deprecated
         */ #removeLegacyProfilesSync(keys) {
            for (const key of keys)localStorage.removeItem(key);
        }
        #normalizeDate(date, now) {
            if (!date) return null;
            for(let time = date; time < now; time *= 1e3){
                if (time >= (0, $gkZs7.arcaeaReleaseTS)) return time;
            }
            return null;
        }
        async #transaction(mode) {
            const db = await this.database.getDB();
            return db.transaction([
                this.database.profiles
            ], mode);
        }
        async #store(mode) {
            const transaction = await this.#transaction(mode);
            return transaction.objectStore(this.database.profiles);
        }
        async #initSQLJS() {
            const initSQLJS = await (0, $dAkPh.esModule)((parcelRequire("7qkQU")));
            return initSQLJS({
                locateFile (url, scriptDirectory) {
                    if (url === "sql-wasm.wasm") return new URL((parcelRequire("5VE1P"))).href;
                    return `https://sql.js.org/dist/${url}`;
                }
            });
        }
        #v1Map = null;
        async #getV1Map() {
            if (!this.#v1Map) {
                const v1Data = await (0, $dAkPh.jsonModule)((parcelRequire("cMZba")));
                const v2Data = await this.chartService.getSongData();
                const validV2ChartIds = new Set(v2Data.flatMap((song)=>song.charts.map((chart)=>chart.id)));
                Object.assign({
                    validV2ChartIds: validV2ChartIds
                });
                this.#v1Map = Object.fromEntries(v1Data.flatMap((song)=>song.charts.map((chart)=>{
                        const newId = `${song.sid}@${chart.difficulty}`;
                        if (!validV2ChartIds.has(newId)) console.error(`${newId} cannot be resolved`);
                        const oldIdLower = chart.id.toLowerCase();
                        return [
                            oldIdLower,
                            newId
                        ];
                    })));
            }
            return this.#v1Map;
        }
    };
    return ProfileServiceImpl = _classThis;
})();

});
parcelRegister("6vc4O", function(module, exports) {

$parcel$export(module.exports, "readFile", () => $4bbf017b7718aea3$export$72c04af63de9061a);
$parcel$export(module.exports, "readBinary", () => $4bbf017b7718aea3$export$751933526e2c6d4b);
function $4bbf017b7718aea3$export$72c04af63de9061a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = (e)=>{
            const { result: result } = reader;
            if (typeof result === "string") resolve(result);
            else reject();
        };
        reader.onerror = reject;
        reader.readAsText(file, "utf-8");
    });
}
function $4bbf017b7718aea3$export$751933526e2c6d4b(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            const result = reader.result;
            if (result instanceof ArrayBuffer) resolve(result);
            else reject();
        };
        reader.readAsArrayBuffer(file);
    });
}

});

parcelRegister("2Svg7", function(module, exports) {

$parcel$export(module.exports, "FancyDialog", () => $2188df50836660d8$export$290d9f7df84a6c68);
$parcel$export(module.exports, "confirm", () => $2188df50836660d8$export$715f9d76bb8c1fea);
$parcel$export(module.exports, "alert", () => $2188df50836660d8$export$5ea928c9faf85bd3);

var $2v1vl = parcelRequire("2v1vl");

var $es6JP = parcelRequire("es6JP");

var $3WBUX = parcelRequire("3WBUX");
parcelRequire("l72Zw");
var $kOWJ5 = parcelRequire("kOWJ5");

var $guLfS = parcelRequire("guLfS");
let $2188df50836660d8$export$290d9f7df84a6c68 = (()=>{
    let _classDecorators = [
        (0, $guLfS.Component)({
            tag: "fancy-dialog",
            styles: [
                (0, $3WBUX.sheet),
                (0, $kOWJ5.sheet)
            ]
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $guLfS.HyplateElement);
    var FancyDialog = class extends _classSuper {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            (0, $2v1vl.__esDecorate)(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            FancyDialog = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            (0, $2v1vl.__runInitializers)(_classThis, _classExtraInitializers);
        }
        dialog = (0, $guLfS.element)("dialog");
        content = (0, $guLfS.signal)((0, $guLfS.nil));
        #renderedSlot = null;
        render() {
            this.effect(()=>(0, $guLfS.listen)(this.dialog)("close", ()=>{
                    this.content.set((0, $guLfS.nil));
                    this.#unmountSlots();
                }));
            return (0, $es6JP.jsx)("dialog", {
                ref: this.dialog,
                children: (0, $es6JP.jsx)((0, $guLfS.Show), {
                    when: this.content,
                    children: (node)=>node
                })
            });
        }
        showAlert(message, useSlot) {
            if (useSlot) this.#renderedSlot = (0, $guLfS.mount)((0, $es6JP.jsx)((0, $es6JP.Fragment), {
                children: message
            }), this);
            return new Promise((resolve)=>{
                this.content.set((0, $es6JP.jsxs)("div", {
                    class: "modal-root",
                    part: "modal-root",
                    children: [
                        (0, $es6JP.jsx)("div", {
                            class: "modal-content mb-3",
                            children: useSlot ? (0, $es6JP.jsx)("slot", {
                                name: "content"
                            }) : message
                        }),
                        (0, $es6JP.jsx)("div", {
                            class: "modal-footer",
                            children: (0, $es6JP.jsx)("button", {
                                type: "button",
                                class: "btn btn-primary",
                                onClick: ()=>{
                                    this.dialog.close();
                                    resolve();
                                },
                                children: "\u786E\u8BA4"
                            })
                        })
                    ]
                }));
                this.dialog.showModal();
            });
        }
        done = ()=>this.dialog.close("confirm");
        cancel = ()=>this.dialog.close("cancel");
        showConfirm(message, renderFooter) {
            return new Promise((resolve)=>{
                this.content.set((0, $es6JP.jsxs)("div", {
                    part: "modal-root",
                    class: "modal-root",
                    onSubmit: (e)=>{
                        e.preventDefault();
                        this.done();
                    },
                    children: [
                        (0, $es6JP.jsx)("div", {
                            class: "modal-content mb-3",
                            children: message
                        }),
                        (0, $es6JP.jsx)("div", {
                            class: "modal-footer",
                            children: (renderFooter ?? ((done, cancel)=>[
                                    (0, $es6JP.jsx)("button", {
                                        type: "button",
                                        class: "btn btn-primary",
                                        onClick: done,
                                        children: "\u786E\u8BA4"
                                    }),
                                    (0, $es6JP.jsx)("button", {
                                        type: "button",
                                        class: "btn btn-secondary",
                                        onClick: cancel,
                                        children: "\u53D6\u6D88"
                                    })
                                ]))(this.done, this.cancel)
                        })
                    ]
                }));
                this.dialog.onclose = ()=>{
                    switch(this.dialog.returnValue){
                        case "confirm":
                            resolve(true);
                            break;
                        default:
                            resolve(false);
                            break;
                    }
                };
                this.dialog.showModal();
            });
        }
        showPicker(renderContents) {
            return new Promise((resolve)=>{
                this.#renderedSlot = (0, $guLfS.mount)((0, $es6JP.jsx)((0, $es6JP.Fragment), {
                    children: renderContents((value)=>{
                        resolve(value);
                        this.done();
                    }, ()=>{
                        resolve(null);
                        this.cancel();
                    })
                }), this);
                this.content.set((0, $es6JP.jsxs)("div", {
                    part: "modal-root",
                    class: "modal-root",
                    onSubmit: (e)=>{
                        e.preventDefault();
                        this.done();
                    },
                    children: [
                        (0, $es6JP.jsx)("div", {
                            class: "modal-content mb-3",
                            children: (0, $es6JP.jsx)("slot", {
                                name: "content"
                            })
                        }),
                        (0, $es6JP.jsx)("div", {
                            class: "modal-footer",
                            children: (0, $es6JP.jsx)("slot", {
                                name: "footer"
                            })
                        })
                    ]
                }));
                this.dialog.onclose = this.dialog.oncancel = ()=>resolve(null);
                this.dialog.showModal();
            });
        }
        #unmountSlots() {
            const unmountIf = (content)=>content && (0, $guLfS.unmount)(content);
            unmountIf(this.#renderedSlot);
            this.#renderedSlot = null;
            this.innerHTML = "";
        }
    };
    return FancyDialog = _classThis;
})();
const $2188df50836660d8$var$globalMessage = new $2188df50836660d8$export$290d9f7df84a6c68();
const $2188df50836660d8$var$ensureInDocument = ()=>{
    if (!$2188df50836660d8$var$globalMessage.isConnected) document.body.appendChild($2188df50836660d8$var$globalMessage);
};
const $2188df50836660d8$export$715f9d76bb8c1fea = (message, renderFooter)=>{
    $2188df50836660d8$var$ensureInDocument();
    return $2188df50836660d8$var$globalMessage.showConfirm(message, renderFooter);
};
const $2188df50836660d8$export$5ea928c9faf85bd3 = (message)=>{
    $2188df50836660d8$var$ensureInDocument();
    return $2188df50836660d8$var$globalMessage.showAlert(message);
};

});
parcelRegister("3WBUX", function(module, exports) {

$parcel$export(module.exports, "sheet", () => $2df4338fabc33a55$export$995990c5c04c46f0);

var $bZWYA = parcelRequire("bZWYA");
let $2df4338fabc33a55$export$6f093cfa640b7166 = "dialog{border-width:var(--bs-border-width);border-radius:var(--bs-border-radius);border-color:var(--bs-border-color);box-shadow:var(--bs-box-shadow);--bs-modal-footer-gap:4px}.modal-root{min-width:240px;display:flex;flex-direction:column}.modal-content{flex-grow:1}";
const $2df4338fabc33a55$export$995990c5c04c46f0 = (0, $bZWYA.create)($2df4338fabc33a55$export$6f093cfa640b7166, "file:///src/view/components/fancy-dialog/style.css.js");

});


parcelRegister("gkZs7", function(module, exports) {

$parcel$export(module.exports, "delay", () => $be4e2ecf4e1cbc2b$export$1391212d75b2ee65);
$parcel$export(module.exports, "duration", () => $be4e2ecf4e1cbc2b$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "getDateFromDatetimeLocal", () => $be4e2ecf4e1cbc2b$export$6ca98ba4e48606a3);
$parcel$export(module.exports, "setDateToDatetimeLocal", () => $be4e2ecf4e1cbc2b$export$dc4460d49bbd0ca8);
$parcel$export(module.exports, "getNow", () => $be4e2ecf4e1cbc2b$export$3991332aae1fc754);
$parcel$export(module.exports, "arcaeaReleaseTS", () => $be4e2ecf4e1cbc2b$export$e6ab969ca6f80afb);

var $lxieH = parcelRequire("lxieH");
const $be4e2ecf4e1cbc2b$export$1391212d75b2ee65 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $be4e2ecf4e1cbc2b$var$secondMS = 1000;
const $be4e2ecf4e1cbc2b$var$minuteMS = 60 * $be4e2ecf4e1cbc2b$var$secondMS;
const $be4e2ecf4e1cbc2b$var$hourMS = 60 * $be4e2ecf4e1cbc2b$var$minuteMS;
const $be4e2ecf4e1cbc2b$var$dayMS = 24 * $be4e2ecf4e1cbc2b$var$hourMS;
const $be4e2ecf4e1cbc2b$var$suffix = [
    "d",
    "H",
    "m",
    "s"
];
const $be4e2ecf4e1cbc2b$var$factors = [
    $be4e2ecf4e1cbc2b$var$dayMS,
    $be4e2ecf4e1cbc2b$var$hourMS,
    $be4e2ecf4e1cbc2b$var$minuteMS,
    $be4e2ecf4e1cbc2b$var$secondMS
];
const $be4e2ecf4e1cbc2b$export$1f34108aa9eb96ab = (time, now)=>{
    const duration = now - time;
    let q = 0, r = duration;
    for(let i = 0; i < $be4e2ecf4e1cbc2b$var$factors.length; i++){
        const factor = $be4e2ecf4e1cbc2b$var$factors[i];
        [q, r] = (0, $lxieH.divide)(r, factor);
        if (q > 0) return `${q}${$be4e2ecf4e1cbc2b$var$suffix[i]}`;
    }
    return "now";
};
const $be4e2ecf4e1cbc2b$export$6ca98ba4e48606a3 = (input)=>{
    return new Date(input.value);
};
const $be4e2ecf4e1cbc2b$export$dc4460d49bbd0ca8 = (input, date)=>{
    input.value = new Date(+date - date.getTimezoneOffset() * $be4e2ecf4e1cbc2b$var$minuteMS).toISOString().slice(0, -5);
};
const $be4e2ecf4e1cbc2b$export$3991332aae1fc754 = ()=>new Date(Date.now());
const $be4e2ecf4e1cbc2b$var$releaseDate = new Date();
$be4e2ecf4e1cbc2b$var$releaseDate.setFullYear(2017);
$be4e2ecf4e1cbc2b$var$releaseDate.setMonth(3);
$be4e2ecf4e1cbc2b$var$releaseDate.setDate(9);
const $be4e2ecf4e1cbc2b$export$e6ab969ca6f80afb = +$be4e2ecf4e1cbc2b$var$releaseDate;

});
parcelRegister("lxieH", function(module, exports) {

$parcel$export(module.exports, "inferRange", () => $fadad355eef6597e$export$9ff9937a867ed215);
$parcel$export(module.exports, "isInt", () => $fadad355eef6597e$export$357fc28f6427af8b);
$parcel$export(module.exports, "divide", () => $fadad355eef6597e$export$cd007d971a5a2143);
$parcel$export(module.exports, "sum", () => $fadad355eef6597e$export$8a63f25cc62965f1);
$parcel$export(module.exports, "truncate", () => $fadad355eef6597e$export$6a506b36fdea397d);
$parcel$export(module.exports, "solve", () => $fadad355eef6597e$export$2865df1f26e73f8e);
const $fadad355eef6597e$export$9ff9937a867ed215 = (value, digit, round)=>{
    const int = Math.floor(value * 10 ** digit);
    const padded = int * 10;
    const base = 10 ** (digit + 1);
    const min = padded - (round ? 5 : 0), max = padded + (round ? 5 : 10);
    return [
        min / base,
        max / base
    ];
};
const $fadad355eef6597e$export$357fc28f6427af8b = Number.isInteger;
const $fadad355eef6597e$export$cd007d971a5a2143 = (a, b)=>{
    const quotient = Math.floor(a / b);
    const remainder = a - quotient * b;
    return [
        quotient,
        remainder
    ];
};
const $fadad355eef6597e$export$8a63f25cc62965f1 = (arr)=>arr.reduce((s, curr)=>s + curr, 0);
const $fadad355eef6597e$export$6a506b36fdea397d = (num, digit)=>{
    const zoom = 10 ** digit;
    const integer = Math.floor(num * zoom);
    return (integer / zoom).toFixed(digit);
};
const $fadad355eef6597e$export$6074e20ba5c64bef = (n, zero)=>// @ts-expect-error cannot check
    Array.from({
        length: n
    }, ()=>structuredClone(zero));
const $fadad355eef6597e$var$vectorOrder = (mat)=>{
    // @ts-expect-error cannot check.
    return mat.length;
};
const $fadad355eef6597e$export$3286a381998301e1 = (mat)=>{
    const n = mat.length;
    return mat.every((r)=>r.length === n);
};
const $fadad355eef6597e$export$dd06af4cc84752a3 = (mat, r, c)=>{
    const data = mat;
    const cofactor = data.filter((_, i)=>i !== r).map((row)=>row.filter((_, j)=>j !== c));
    if ($fadad355eef6597e$export$3286a381998301e1(cofactor)) return $fadad355eef6597e$export$d063d65fed97e7fa(cofactor);
    return 0;
};
const $fadad355eef6597e$export$d063d65fed97e7fa = (mat)=>{
    const data = mat;
    if (!$fadad355eef6597e$export$3286a381998301e1(mat)) throw new Error(`input is not a square matrix.`);
    let sum = 0, sign = 1, n = $fadad355eef6597e$var$vectorOrder(mat);
    if (n === 1) return data[0][0];
    for(let i = 0, l = n; i < l; ++i){
        sum += sign * data[i][0] * $fadad355eef6597e$export$dd06af4cc84752a3(mat, i, 0);
        sign *= -1;
    }
    return sum;
};
const $fadad355eef6597e$export$2865df1f26e73f8e = (mat)=>{
    const data = mat;
    const n = $fadad355eef6597e$var$vectorOrder(mat);
    const solution = $fadad355eef6597e$export$6074e20ba5c64bef(n, 0);
    const A = data.map((r)=>r.slice(0, -1));
    if (!$fadad355eef6597e$export$3286a381998301e1(A)) throw new Error(`Invalid augmented matrix demension.`);
    const d = $fadad355eef6597e$export$d063d65fed97e7fa(A);
    for(let i = 0; i < n; ++i){
        const square = structuredClone(A);
        for(let j = 0; j < n; ++j){
            const squareData = square;
            squareData[j][i] = data[j].at(-1);
        }
        const vec = solution;
        vec[i] = $fadad355eef6597e$export$d063d65fed97e7fa(square) / d;
    }
    return solution;
};

});


parcelRegister("d85fI", function(module, exports) {

$parcel$export(module.exports, "DBVersionManager", () => $98f018c023f0f1c2$export$2c82e64db1c95a50);
$parcel$export(module.exports, "openDB", () => $98f018c023f0f1c2$export$ca0ed41b1a2af7e);
$parcel$export(module.exports, "prefixWith", () => $98f018c023f0f1c2$export$33dde070747c7f6d);
$parcel$export(module.exports, "requestToPromise", () => $98f018c023f0f1c2$export$85ceed0783e42041);
$parcel$export(module.exports, "transactionToPromise", () => $98f018c023f0f1c2$export$2a5213bce1720b42);
$parcel$export(module.exports, "moveData", () => $98f018c023f0f1c2$export$e1889ff735213438);
class $98f018c023f0f1c2$export$2c82e64db1c95a50 {
    #versions = new Map();
    version(version, migrate) {
        this.#versions.set(version, migrate);
        return this;
    }
    async open(name, version) {
        let oldVersion = 0, newVersion = version;
        let db = null;
        const dbs = await indexedDB.databases?.() ?? [];
        const targetDB = dbs.find((db)=>db.name === name);
        oldVersion = targetDB?.version ?? 0;
        if (!oldVersion) // 除了首次访问，还有可能是Firefox 不支持indexedDB.databses方法，无法获取当前数据库的版本
        return $98f018c023f0f1c2$export$ca0ed41b1a2af7e(name, version, (event, request)=>{
            const db = request.result;
            const { oldVersion: oldVersion, newVersion: newVersion } = event;
            if (newVersion == null) throw new Error(`Unexpected Error: DB ${name} is being deleted.`);
            const upgradeRange = this.#getUpgradeRange(oldVersion, newVersion);
            for (const [, upgrade] of upgradeRange)upgrade(db, ()=>{
            // 在Firefox支持indexedDB.databases之前只能放弃所有数据迁移步骤
            });
        });
        const upgradeRange = this.#getUpgradeRange(oldVersion, newVersion);
        let currentVersion = oldVersion;
        for (const [nextVersion, upgrade] of upgradeRange){
            let migrations = [];
            db?.close();
            const currentDB = await $98f018c023f0f1c2$export$ca0ed41b1a2af7e(name, nextVersion, (event, request)=>{
                const { oldVersion: oldVersion, newVersion: newVersion } = event;
                if (newVersion == null) throw new Error(`Unexpected Error: DB ${name} is being deleted.`);
                console.assert(oldVersion === currentVersion, `old version does not match: ${oldVersion} != ${currentVersion}`);
                console.assert(newVersion === nextVersion, `new version does not match: ${newVersion} != ${nextVersion}`);
                const db = request.result;
                upgrade(db, (apply)=>{
                    migrations.push(apply);
                });
            });
            if (migrations.length) {
                console.debug(`Migrating data of ${name} from v${currentVersion} to v${nextVersion}...`);
                await Promise.all(migrations.map((migrate)=>migrate(currentDB)));
            }
            db = currentDB;
            currentVersion = nextVersion;
        }
        if (!db) throw new Error(`Version ${version} of database "${name}" not defined.`);
        return db;
    }
    #getUpgradeRange(oldVersion, newVersion) {
        return [
            ...this.#versions.entries()
        ].filter(([version])=>oldVersion <= version && version <= newVersion).sort(([a], [b])=>a - b);
    }
}
const $98f018c023f0f1c2$export$ca0ed41b1a2af7e = (name, version, onupgradeneeded)=>new Promise((resolve, reject)=>{
        const openRequest = indexedDB.open(name, version);
        openRequest.onerror = reject;
        openRequest.onupgradeneeded = (event)=>{
            if (!(event instanceof IDBVersionChangeEvent)) return;
            onupgradeneeded(event, openRequest);
        };
        openRequest.onsuccess = ()=>{
            resolve(openRequest.result);
        };
    });
const $98f018c023f0f1c2$export$33dde070747c7f6d = (prefix)=>{
    const upperBound = prefix.slice(0, -1) + String.fromCharCode(prefix.at(-1).charCodeAt(0));
    return IDBKeyRange.bound(prefix, upperBound, false, true);
};
const $98f018c023f0f1c2$export$85ceed0783e42041 = (query, options)=>new Promise((resolve, reject)=>{
        query.onsuccess = ()=>{
            resolve(query.result);
        };
        query.onerror = (e)=>{
            console.error(e);
            if (options?.emitError) reject(e);
            else resolve(null);
        };
    });
const $98f018c023f0f1c2$export$2a5213bce1720b42 = (transaction, options)=>new Promise((resolve, reject)=>{
        transaction.onerror = reject;
        transaction.onabort = reject;
        transaction.oncomplete = ()=>resolve();
    });
const $98f018c023f0f1c2$export$e1889ff735213438 = async (from, to)=>{
    const oldObjects = await $98f018c023f0f1c2$export$85ceed0783e42041(from.db.transaction([
        from.store
    ]).objectStore(from.store).getAll());
    if (oldObjects) {
        const transaction = to.db.transaction([
            to.store
        ], "readwrite");
        const store = transaction.objectStore(to.store);
        for (const old of oldObjects)store.put(old);
        await $98f018c023f0f1c2$export$2a5213bce1720b42(transaction);
    }
};
const $98f018c023f0f1c2$export$22a559d62c12b7ff = (name)=>$98f018c023f0f1c2$export$85ceed0783e42041(indexedDB.deleteDatabase(name), {
        emitError: true
    });

});

parcelRegister("bESPZ", function(module, exports) {

$parcel$export(module.exports, "e", () => $87cdf7c000246b69$export$f1e1789686576879);
$parcel$export(module.exports, "B", () => $87cdf7c000246b69$export$ef35774e6d314e91);
const $87cdf7c000246b69$export$7ccc53e8f1e7dfc5 = ()=>{}, $87cdf7c000246b69$export$4368d992c4eafac0 = (t)=>t, $87cdf7c000246b69$export$f1e1789686576879 = (t)=>{
    throw new Error(t);
}, $87cdf7c000246b69$export$2d1720544b23b823 = (t, e)=>{
    if (!t) return $87cdf7c000246b69$export$f1e1789686576879(e);
}, $87cdf7c000246b69$export$39b482c5e57630a8 = (t, e)=>null == t ? $87cdf7c000246b69$export$f1e1789686576879(e ?? "Not null assertion failed.") : t, $87cdf7c000246b69$export$dda1d9f60106f0e9 = ()=>!0, $87cdf7c000246b69$export$3b14a55fb2447963 = (t)=>(e)=>t.some((t)=>t(e)), $87cdf7c000246b69$export$35e795649ee09318 = (t)=>(e)=>t.every((t)=>t(e)), $87cdf7c000246b69$export$71511d61b312f219 = Symbol.for("@@placeholder"), $87cdf7c000246b69$export$342063e11d6c3cad = (t, e)=>(e ??= t.length, e > 0 ? (...r)=>r.length !== e ? $87cdf7c000246b69$export$f1e1789686576879(`Expected ${e} parameters, got ${r.length} parameters.`) : function(...e) {
            let s = 0;
            const n = r.map((t)=>t === $87cdf7c000246b69$export$71511d61b312f219 ? e[s++] : t);
            return t.apply(this, n);
        } : $87cdf7c000246b69$export$f1e1789686576879("Invalid parameter count.")), $87cdf7c000246b69$export$882b5998b3b9117c = (t)=>(e)=>e[t], $87cdf7c000246b69$export$9e5f44173e64f162 = structuredClone, $87cdf7c000246b69$export$625550452a3fa3ec = (t)=>"string" == typeof t, $87cdf7c000246b69$export$90a7f3efeed30595 = (t)=>"number" == typeof t, $87cdf7c000246b69$export$efccba1c4a2ef57b = (t)=>"boolean" == typeof t, $87cdf7c000246b69$export$d141bba7fdc215a3 = (t)=>"symbol" == typeof t, $87cdf7c000246b69$export$4a5767248b18ef41 = (t)=>"bigint" == typeof t, $87cdf7c000246b69$export$df995fae86a55f06 = (t)=>void 0 === t, $87cdf7c000246b69$export$ebd11618f299a286 = (t)=>null === t, $87cdf7c000246b69$export$ef35774e6d314e91 = (t)=>null == t, $87cdf7c000246b69$export$e7094788287c5e9b = $87cdf7c000246b69$export$3b14a55fb2447963([
    $87cdf7c000246b69$export$625550452a3fa3ec,
    $87cdf7c000246b69$export$d141bba7fdc215a3,
    $87cdf7c000246b69$export$90a7f3efeed30595
]), $87cdf7c000246b69$export$96f57966bedc81b4 = (t)=>"object" == typeof t && null !== t || "function" == typeof t, $87cdf7c000246b69$export$a9c23c6ac3fc3eca = (t)=>"function" == typeof t, $87cdf7c000246b69$export$d66501df72047452 = (t)=>(...e)=>Reflect.construct(t, e), $87cdf7c000246b69$export$2329c99376c9d0a4 = (t)=>Object.prototype.toString.call(t), $87cdf7c000246b69$export$7f8ddf7c7c20b3cd = Object.assign, $87cdf7c000246b69$export$43caf9889c228507 = (t, e)=>{
    const s = [];
    for(let r = 0; r < e; r++)for (const e of t)s.push(e);
    return s;
}, $87cdf7c000246b69$export$407448d2b89b1813 = (t, ...[e])=>Array.from({
        length: t
    }, (t, s)=>$87cdf7c000246b69$export$a9c23c6ac3fc3eca(e) ? e(s) : e), $87cdf7c000246b69$export$8b22cf2602fb60ce = (t, e)=>{
    for (const s of e)t.push(s);
    return t;
}, $87cdf7c000246b69$export$db3b6bfb95261072 = (t, e)=>t.at(e % t.length), $87cdf7c000246b69$export$2408f22a0fab9ae5 = (t)=>t.sort(()=>Math.random() - .5), $87cdf7c000246b69$export$ffb5f4729a158638 = (t, e)=>{
    let s = t.length, r = e.length, n = !0;
    const a = [];
    for(; s > 0 || r > 0;)n && s > 0 ? (s--, a.push(t[s])) : r > 0 && (r--, a.push(e[r])), n = !n;
    return $87cdf7c000246b69$export$8b22cf2602fb60ce(a, (n ? e.slice(0, r) : t.slice(0, s)).reverse()).reverse();
}, $87cdf7c000246b69$export$23f2a1d2818174ef = (t, e)=>t.reduce((t, s)=>(t[e(s)] = s, t), {}), $87cdf7c000246b69$export$953cecd6e717a553 = (t, e)=>Object.fromEntries(Object.entries(t).map(([t, s])=>[
            t,
            e(s, t)
        ]));
class $87cdf7c000246b69$var$R {
    context;
    #t;
    constructor(t, e){
        this.context = t, this.#t = e, e.enter(t);
    }
    [Symbol.dispose]() {
        this.#t.quit();
    }
}
class $87cdf7c000246b69$export$25ce5a424b770e84 {
    #t = [];
    resolve = ()=>this.#t.at(-1);
    enter = (t)=>this.#t.push(t);
    scope = (t)=>new $87cdf7c000246b69$var$R(t, this);
    quit = ()=>this.#t.pop();
    [Symbol.dispose]() {
        this.#t.length = 0;
    }
}
const $87cdf7c000246b69$export$ae1af26003f05816 = ()=>{
    const t = new $87cdf7c000246b69$export$25ce5a424b770e84;
    return [
        t.enter,
        t.quit,
        t.resolve,
        t.scope
    ];
}, $87cdf7c000246b69$var$C = (t)=>`${t} is not integer.`, $87cdf7c000246b69$var$D = "Matrix is not square.";
class $87cdf7c000246b69$export$9bb611d729802a56 {
    start;
    stop;
    step;
    direction;
    constructor(...t){
        let e, s, r;
        1 === t.length ? [e, s, r] = [
            0,
            t[0],
            1
        ] : [e, s, r] = [
            t[0],
            t[1],
            t[2] ?? 1
        ];
        const n = [
            e,
            s,
            r
        ].find((t)=>!Number.isInteger(t));
        if (n) throw new Error($87cdf7c000246b69$var$C(n));
        if (0 === r) throw new Error("Step cannot be zero.");
        this.direction = Math.sign(s - e), this.start = e, this.stop = s, this.step = r;
    }
    #e(t) {
        return this.direction > 0 ? this.start <= t : t <= this.start;
    }
    #s(t) {
        return this.direction > 0 ? t < this.stop : this.stop < t;
    }
    between(t) {
        return this.#e(t) && this.#s(t);
    }
    contains(t) {
        return !!this.between(t) && Number.isInteger((t - this.start) / this.step);
    }
    *[Symbol.iterator]() {
        if (Math.sign(this.step) === this.direction) for(let t = this.start; this.#s(t); t += this.step)yield t;
    }
}
const $87cdf7c000246b69$export$b4171a6734a65d42 = $87cdf7c000246b69$export$d66501df72047452($87cdf7c000246b69$export$9bb611d729802a56), $87cdf7c000246b69$export$3466f893ebf79586 = (t)=>t.reduce((t, e)=>Math.max(t, e), -1 / 0), $87cdf7c000246b69$export$61196ced6d74a310 = (t)=>t.reduce((t, e)=>t + e, 0), $87cdf7c000246b69$export$3a1a48c8f6ef640e = (t, e)=>{
    const s = Math.floor(t / e);
    return [
        s,
        t - s * e
    ];
}, $87cdf7c000246b69$export$a07804094c3ecf2d = (t, e)=>{
    let s;
    for(t = Math.abs(t), e = Math.abs(e); e > 0;)s = t % e, t = e, e = s;
    return t;
}, $87cdf7c000246b69$export$c4ce752e73470fba = (t, e)=>Array.from({
        length: t
    }, ()=>structuredClone(e)), $87cdf7c000246b69$export$56c0d5a1e737357d = (t)=>t, $87cdf7c000246b69$export$3722cfe417b6ed86 = (t)=>t.length, $87cdf7c000246b69$export$db202ddc8be9136 = (t)=>{
    if (!Array.isArray(t)) return !1;
    const e = t[0];
    return !(null == e || !Array.isArray(e) || e.length <= 0) && t.every((t)=>Array.isArray(t) && t.length === e.length && t.every($87cdf7c000246b69$export$90a7f3efeed30595));
}, $87cdf7c000246b69$export$971d5caa766a69d7 = (t)=>{
    const e = t.length;
    return t.every((t)=>t.length === e);
}, $87cdf7c000246b69$export$3a6d5c9ae78a2c08 = (t, e, r)=>{
    if (!$87cdf7c000246b69$export$971d5caa766a69d7(t)) return $87cdf7c000246b69$export$f1e1789686576879($87cdf7c000246b69$var$D);
    const n = t.filter((t, s)=>s !== e).map((t)=>t.filter((t, e)=>e !== r));
    return $87cdf7c000246b69$export$e7c866399fa523f5(n);
}, $87cdf7c000246b69$export$e7c866399fa523f5 = (t)=>{
    if (!$87cdf7c000246b69$export$971d5caa766a69d7(t)) return $87cdf7c000246b69$export$f1e1789686576879($87cdf7c000246b69$var$D);
    let e = 0, r = 1, n = $87cdf7c000246b69$export$3722cfe417b6ed86(t);
    if (1 === n) return t[0][0];
    for(let s = 0, a = n; s < a; ++s)e += r * t[s][0] * $87cdf7c000246b69$export$3a6d5c9ae78a2c08(t, s, 0), r *= -1;
    return e;
}, $87cdf7c000246b69$export$71cec2538cb2c617 = (t)=>{
    const e = $87cdf7c000246b69$export$3722cfe417b6ed86(t), s = $87cdf7c000246b69$export$c4ce752e73470fba(e, 0), r = t.map((t)=>t.slice(0, -1));
    if (!$87cdf7c000246b69$export$971d5caa766a69d7(r)) throw new Error("Invalid augmented matrix demension.");
    const n = $87cdf7c000246b69$export$e7c866399fa523f5(r);
    for(let a = 0; a < e; ++a){
        const i = structuredClone(r);
        for(let s = 0; s < e; ++s)i[s][a] = t[s].at(-1);
        s[a] = $87cdf7c000246b69$export$e7c866399fa523f5(i) / n;
    }
    return s;
};
class $87cdf7c000246b69$export$78acf4525d8a74c4 {
    static round(t, e) {
        const s = Math.round(t / e.valueOf());
        return e.mul(new $87cdf7c000246b69$export$78acf4525d8a74c4(s));
    }
    static floor(t, e) {
        const s = Math.floor(t / e.valueOf());
        return e.mul(new $87cdf7c000246b69$export$78acf4525d8a74c4(s));
    }
    p;
    q;
    constructor(t, e = 1){
        if (!Number.isInteger(t)) throw new Error($87cdf7c000246b69$var$C(t));
        if (!Number.isInteger(e)) throw new Error($87cdf7c000246b69$var$C(e));
        if (0 === e) throw new Error("Division by zero.");
        const s = $87cdf7c000246b69$export$a07804094c3ecf2d(t, e);
        this.p = t / s, this.q = e / s, this.q < 0 && (this.p = -this.p, this.q = -this.q);
    }
    isInteger() {
        return 1 === this.q;
    }
    isZero() {
        return 0 === this.p;
    }
    add(t) {
        return $87cdf7c000246b69$export$8743009a87fcb00f(this.p * t.q + this.q * t.p, this.q * t.q);
    }
    sub(t) {
        return $87cdf7c000246b69$export$8743009a87fcb00f(this.p * t.q - this.q * t.p, this.q * t.q);
    }
    mul(t) {
        return $87cdf7c000246b69$export$8743009a87fcb00f(this.p * t.p, this.q * t.q);
    }
    div(t) {
        return $87cdf7c000246b69$export$8743009a87fcb00f(this.p * t.q, this.q * t.p);
    }
    inv() {
        return $87cdf7c000246b69$export$8743009a87fcb00f(this.q, this.p);
    }
    lt(t) {
        return this.p * t.q < this.q * t.p;
    }
    le(t) {
        return this.p * t.q <= this.q * t.p;
    }
    eq(t) {
        return this.p === t.p && this.q === t.q;
    }
    ge(t) {
        return this.p * t.q >= this.q * t.p;
    }
    gt(t) {
        return this.p * t.q > this.q * t.p;
    }
    min(t) {
        return this.lt(t) ? this : t;
    }
    max(t) {
        return this.gt(t) ? this : t;
    }
    toString() {
        return `${this.p}/${this.q}`;
    }
    valueOf() {
        return this.p / this.q;
    }
}
const $87cdf7c000246b69$export$8743009a87fcb00f = $87cdf7c000246b69$export$d66501df72047452($87cdf7c000246b69$export$78acf4525d8a74c4);
class $87cdf7c000246b69$export$dc98b0b04f4c7758 extends Number {
    static round(t, e) {
        const s = 10 ** e, r = Math.round(t * s);
        return new $87cdf7c000246b69$export$dc98b0b04f4c7758(r / s, e);
    }
    static floor(t, e) {
        const s = 10 ** e, r = Math.floor(t * s);
        return new $87cdf7c000246b69$export$dc98b0b04f4c7758(r / s, e);
    }
    digits;
    constructor(t, e){
        if (super(t), !Number.isInteger(e)) throw new Error($87cdf7c000246b69$var$C(e));
        this.digits = e;
    }
    toString(t) {
        if (t) return super.toString(t);
        const e = this.valueOf(), s = 10 ** this.digits;
        return (Math.round(e * s) / s).toFixed(this.digits);
    }
    floor() {
        const t = this.valueOf();
        return $87cdf7c000246b69$export$dc98b0b04f4c7758.floor(t, this.digits).toFixed(this.digits);
    }
}
const $87cdf7c000246b69$export$3d8c2f653ac9d0b9 = $87cdf7c000246b69$export$d66501df72047452($87cdf7c000246b69$export$dc98b0b04f4c7758), $87cdf7c000246b69$export$34aec0b863436764 = class {
    #r;
    constructor(t){
        this.#r = $87cdf7c000246b69$export$9e5f44173e64f162(t), Object.defineProperties(this, $87cdf7c000246b69$export$953cecd6e717a553(t, (t, e)=>({
                configurable: !1,
                enumerable: !0,
                get: ()=>this.$get(e),
                set: (t)=>this.$set(e, t)
            })));
    }
    $data() {
        return this.#r;
    }
    $get(t) {
        return Reflect.get(this.#r, t);
    }
    $set(t, e) {
        return Reflect.set(this.#r, t, e);
    }
}, $87cdf7c000246b69$export$3c2fa207a37baaea = (t, ...e)=>String.raw({
        raw: t
    }, ...e), $87cdf7c000246b69$export$ce26c07117d59d6a = (t)=>(e, ...r)=>{
        const n = new Set(r.filter($87cdf7c000246b69$export$625550452a3fa3ec)).difference(new Set(Reflect.ownKeys(t)));
        return n.size ? $87cdf7c000246b69$export$f1e1789686576879(`Unknown properties: ${$87cdf7c000246b69$export$c3950d9923825c02([
            ...n
        ])}`) : (s)=>$87cdf7c000246b69$export$3c2fa207a37baaea(e, ...r.map((e)=>$87cdf7c000246b69$export$e7094788287c5e9b(e) ? t[e](s) : e(s)));
    }, $87cdf7c000246b69$export$6559d589eb85fbb6 = (t)=>{
    const e = `${t}`;
    return ()=>e;
}, $87cdf7c000246b69$export$efca4cbe5dd06740 = (t)=>{
    let e = `${t}`;
    const s = ()=>e;
    return s.set = (t)=>{
        e = `${t}`;
    }, s;
}, $87cdf7c000246b69$export$a8550f7dbe79f93a = (t, ...e)=>$87cdf7c000246b69$export$3c2fa207a37baaea(t, ...e.map((t)=>t())), $87cdf7c000246b69$export$2e2af4578d910ddf = (t, ...e)=>(s)=>$87cdf7c000246b69$export$3c2fa207a37baaea(t, ...e.map((t)=>t(s))), $87cdf7c000246b69$export$a93c5207d687da10 = (t)=>null != t ? `${t}` : "", $87cdf7c000246b69$export$c3950d9923825c02 = (t)=>t.map(String).join(", "), $87cdf7c000246b69$export$a9c996f45e5784d0 = (t, e = 2)=>JSON.stringify(t, void 0, e), $87cdf7c000246b69$export$7910e0436ed8d1de = (t)=>$87cdf7c000246b69$export$a93c5207d687da10(t.stack) || t.message, $87cdf7c000246b69$export$555508cbc6add439 = (t)=>(e, ...r)=>{
        const n = new Set(r), a = new Set(Reflect.ownKeys(t)), i = n.difference(a);
        if (i.size) return $87cdf7c000246b69$export$f1e1789686576879(`Unknown properties: ${$87cdf7c000246b69$export$c3950d9923825c02([
            ...i
        ])}`);
        const o = a.difference(n);
        if (o.size) return $87cdf7c000246b69$export$f1e1789686576879(`Unused properties: ${$87cdf7c000246b69$export$c3950d9923825c02([
            ...o
        ])}`);
        const h = new Set;
        for (const t of r)n.has(t) ? n.delete(t) : h.add(t);
        if (h.size) return $87cdf7c000246b69$export$f1e1789686576879(`Duplicated properties: ${$87cdf7c000246b69$export$c3950d9923825c02([
            ...h
        ])}`);
        const u = String.raw(e, ...r.map((e)=>{
            const s = t[e];
            return `(${s instanceof RegExp ? s.source : s.match.source})`;
        }));
        return (e)=>{
            const s = new RegExp(u).exec(e);
            return s ? Object.fromEntries(r.map((e, r)=>{
                const n = t[e], a = s[r + 1];
                return [
                    e,
                    n instanceof RegExp ? a : n.as(a)
                ];
            })) : null;
        };
    }, $87cdf7c000246b69$export$2219238a014317b0 = (t)=>new Promise((e)=>setTimeout(e, t)), $87cdf7c000246b69$var$mt = (t, e)=>`${t}`.padStart(e, "0"), $87cdf7c000246b69$export$4c3d22f3d993c33f = $87cdf7c000246b69$export$ce26c07117d59d6a({
    YYYY: (t)=>t.getFullYear(),
    MM: (t)=>$87cdf7c000246b69$var$mt(t.getMonth() + 1, 2),
    dd: (t)=>$87cdf7c000246b69$var$mt(t.getDate(), 2),
    HH: (t)=>$87cdf7c000246b69$var$mt(t.getHours(), 2),
    mm: (t)=>$87cdf7c000246b69$var$mt(t.getMinutes(), 2),
    ss: (t)=>$87cdf7c000246b69$var$mt(t.getSeconds(), 2),
    SSS: (t)=>$87cdf7c000246b69$var$mt(t.getMilliseconds(), 3)
}), $87cdf7c000246b69$export$f787f51d84a910ad = $87cdf7c000246b69$export$4c3d22f3d993c33f`${"YYYY"}-${"MM"}-${"dd"}`, $87cdf7c000246b69$export$c9170ad7d4cd7e57 = $87cdf7c000246b69$export$4c3d22f3d993c33f`${"YYYY"}-${"MM"}-${"dd"} ${"HH"}:${"MM"}:${"ss"}`, $87cdf7c000246b69$export$ee7c8ad385a60b7b = $87cdf7c000246b69$export$4c3d22f3d993c33f`${"YYYY"}-${"MM"}-${"dd"} ${"HH"}:${"MM"}:${"ss"}.${"SSS"}`;

});

parcelRegister("7qkQU", function(module, exports) {
module.exports = $parcel$import("j2oJf").then(()=>parcelRequire('kOsec'));

});

parcelRegister("5VE1P", function(module, exports) {
module.exports = $parcel$resolve("8CZrQ");

});

parcelRegister("cMZba", function(module, exports) {
module.exports = $parcel$import("aK2K0").then(()=>parcelRequire('40FEf'));

});


parcelRegister("7EoKU", function(module, exports) {

$parcel$export(module.exports, "CharacterStatus", () => $591f78c229de2fc4$export$8aa5aa332581390d);
$parcel$export(module.exports, "CharacterImageKind", () => $591f78c229de2fc4$export$6243394a19c2832f);
var $591f78c229de2fc4$export$8aa5aa332581390d;
(function(CharacterStatus) {
    CharacterStatus["Initial"] = "";
    CharacterStatus["Awaken"] = "u";
    /**
     * 对立、摩耶丢失的特殊状态
     */ CharacterStatus["Lost"] = "l";
})($591f78c229de2fc4$export$8aa5aa332581390d || ($591f78c229de2fc4$export$8aa5aa332581390d = {}));
var $591f78c229de2fc4$export$6243394a19c2832f;
(function(CharacterImageKind) {
    /**
     * 头像图标
     */ CharacterImageKind[CharacterImageKind["Icon"] = 0] = "Icon";
    /**
     * 立绘
     */ CharacterImageKind[CharacterImageKind["Full"] = 1] = "Full";
})($591f78c229de2fc4$export$6243394a19c2832f || ($591f78c229de2fc4$export$6243394a19c2832f = {}));

});

parcelRegister("l9F69", function(module, exports) {

$parcel$export(module.exports, "BannerType", () => $f66a51824a44cbd2$export$d64159bfaa8703dd);
var $f66a51824a44cbd2$export$d64159bfaa8703dd;
(function(BannerType) {
    BannerType["Course"] = "course";
    BannerType["ArcaeaOnline"] = "aol";
})($f66a51824a44cbd2$export$d64159bfaa8703dd || ($f66a51824a44cbd2$export$d64159bfaa8703dd = {}));

});

parcelRegister("baotA", function(module, exports) {

$parcel$export(module.exports, "protocol", () => $82139d5372ee1eed$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "toolbelt", () => $82139d5372ee1eed$export$1001660f7170b600);
const $82139d5372ee1eed$export$a51d6b395ff4c65a = "arcaea-toolbelt:";
const $82139d5372ee1eed$export$1001660f7170b600 = {
    data: (path)=>new URL(path, `${$82139d5372ee1eed$export$a51d6b395ff4c65a}//data/`),
    assets: (path)=>new URL(path, `${$82139d5372ee1eed$export$a51d6b395ff4c65a}//assets/`)
};

});

parcelRegister("3j82G", function(module, exports) {

$parcel$export(module.exports, "AssetsResolverImpl", () => $26896274f55108c2$export$dc2facd477948474);

var $2v1vl = parcelRequire("2v1vl");

var $8ght1 = parcelRequire("8ght1");

var $LBO4U = parcelRequire("LBO4U");

var $59teg = parcelRequire("59teg");

var $7EoKU = parcelRequire("7EoKU");

var $baotA = parcelRequire("baotA");

var $l9F69 = parcelRequire("l9F69");
let $26896274f55108c2$export$dc2facd477948474 = (()=>{
    let _classDecorators = [
        (0, $8ght1.Injectable)({
            implements: (0, $LBO4U.$AssetsResolver)
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var AssetsResolverImpl = class {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            (0, $2v1vl.__esDecorate)(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            AssetsResolverImpl = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            (0, $2v1vl.__runInitializers)(_classThis, _classExtraInitializers);
        }
        resolve(path) {
            return (0, $baotA.toolbelt).assets(path);
        }
        resoveCharacterImage({ id: id, status: status, kind: kind }) {
            if (id === -1) switch(kind){
                case (0, $7EoKU.CharacterImageKind).Icon:
                    return this.resolve(`char/unknown_icon.png`);
                case (0, $7EoKU.CharacterImageKind).Full:
                default:
                    return this.resolve(`char/-1_mp.png`);
            }
            // 光 & 对立觉醒前后完全一致
            if (id === 5) status = (0, $7EoKU.CharacterStatus).Initial;
            switch(kind){
                case (0, $7EoKU.CharacterImageKind).Icon:
                    return this.resolve(`char/${id}${status}_icon.png`);
                case (0, $7EoKU.CharacterImageKind).Full:
                default:
                    return this.resolve(`char/1080/${id}${status}.png`);
            }
        }
        resolvePotentialBadge(level) {
            return this.resolve(`img/rating_${level >= 0 ? level : "off"}.png`);
        }
        resolveCover(chart, song, hd) {
            const folder = !song.dl ? song.id : `dl_${song.id}`;
            const base = `songs/${folder}`;
            const suffix = hd ? ".jpg" : "_256.jpg";
            const version = chart.override?.cover ? `${(0, $59teg.difficultyIndexes)[chart.difficulty]}` : "base";
            const possible = [
                "",
                "1080_"
            ].map((prefix)=>`${prefix}${version}${suffix}`);
            const file = song.covers.find((cover)=>possible.includes(cover));
            const path = `${base}/${file}`;
            return this.resolve(path);
        }
        resolveUnknownCover() {
            return this.resolve("img/song_jacket_back_colorless.png");
        }
        resolveClearImg(clearType) {
            return this.resolve(`img/clear_type/${this.#getClearAssetsImgName(clearType)}.png`);
        }
        resolveGradeImg(scoreRank) {
            return this.resolve(`img/grade/mini/${this.#getGradeAssetsImgName(scoreRank)}.png`);
        }
        resolveBanner(banner) {
            switch(banner.type){
                case (0, $l9F69.BannerType).ArcaeaOnline:
                    return this.resolve(`img/course/banner/${banner.file}`);
                default:
                    const file = banner.file ?? `course_banner_${banner.level}.png`;
                    return this.resolve(`img/course/banner/${file}`);
            }
        }
        #getClearAssetsImgName(clearType) {
            switch(clearType){
                case (0, $59teg.ClearRank).EasyClear:
                    return "easy";
                case (0, $59teg.ClearRank).TrackLost:
                    return "fail";
                case (0, $59teg.ClearRank).FullRecall:
                    return "full";
                case (0, $59teg.ClearRank).HardClear:
                    return "hard";
                case (0, $59teg.ClearRank).PureMemory:
                case (0, $59teg.ClearRank).Maximum:
                    return "pure";
                case (0, $59teg.ClearRank).NormalClear:
                default:
                    return "normal";
            }
        }
        #getGradeAssetsImgName(grade) {
            return grade.replace("+", "plus").toLowerCase();
        }
    };
    return AssetsResolverImpl = _classThis;
})();

});

parcelRegister("1Nuqs", function(module, exports) {

$parcel$export(module.exports, "PreferenceServiceImpl", () => $14f1f7fd4175274c$export$9b0fc24702c13829);

var $2v1vl = parcelRequire("2v1vl");

var $8ght1 = parcelRequire("8ght1");

var $LBO4U = parcelRequire("LBO4U");

var $guLfS = parcelRequire("guLfS");

var $dAkPh = parcelRequire("dAkPh");

var $d85fI = parcelRequire("d85fI");

var $lfbFX = parcelRequire("lfbFX");
const $14f1f7fd4175274c$var$defaultPreference = {
    // 默认跟随系统的偏好主题
    theme: (0, $lfbFX.getUserTheme)(),
    // 默认开启代理
    ghproxy: true,
    showMaxMinus: false,
    template: {},
    aolWorldBoost: 1
};
let $14f1f7fd4175274c$export$9b0fc24702c13829 = (()=>{
    let _classDecorators = [
        (0, $8ght1.Injectable)({
            implements: (0, $LBO4U.$PreferenceService),
            requires: [
                (0, $LBO4U.$Database)
            ]
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var PreferenceServiceImpl = class {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            (0, $2v1vl.__esDecorate)(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            PreferenceServiceImpl = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            (0, $2v1vl.__runInitializers)(_classThis, _classExtraInitializers);
        }
        database;
        #preference = (0, $guLfS.signal)((0, $dAkPh.clone)($14f1f7fd4175274c$var$defaultPreference));
        #computed = {};
        constructor(database){
            this.database = database;
            this.get().then((latest)=>this.#notify(latest));
        }
        async get() {
            const db = await this.database.getDB();
            const configStore = this.database.preference;
            const stored = await (0, $d85fI.requestToPromise)(db.transaction([
                configStore
            ]).objectStore(configStore).getAll()) ?? [];
            const partialConfig = Object.fromEntries(stored.map(({ key: key, value: value })=>[
                    key,
                    value
                ]));
            return {
                ...$14f1f7fd4175274c$var$defaultPreference,
                ...partialConfig
            };
        }
        async update(patch) {
            const current = await this.get();
            const newPreference = {
                ...current,
                ...patch
            };
            const db = await this.database.getDB();
            const configStore = this.database.preference;
            const transaction = db.transaction([
                configStore
            ], "readwrite");
            const store = transaction.objectStore(configStore);
            for(const key in patch){
                const value = Reflect.get(patch, key);
                const config = {
                    key: key,
                    value: value
                };
                store.put(config);
            }
            await (0, $d85fI.transactionToPromise)(transaction);
            this.#notify(newPreference);
        }
        signal(name) {
            // @ts-expect-error key access does not match value
            const signal = this.#computed[name] ??= (0, $guLfS.computed)(()=>this.#preference()[name]);
            return signal;
        }
        #notify(latest) {
            this.#preference.set(latest);
        }
    };
    return PreferenceServiceImpl = _classThis;
})();

});
parcelRegister("lfbFX", function(module, exports) {

$parcel$export(module.exports, "getUserTheme", () => $f7740e3eb5a13468$export$7442efdced193dc0);
const $f7740e3eb5a13468$export$7442efdced193dc0 = ()=>window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

});


parcelRegister("cNtQA", function(module, exports) {

$parcel$export(module.exports, "ArcaeaToolbeltDatabaseContext", () => $951136ac6521859b$export$a77041a9872c5f6);

var $2v1vl = parcelRequire("2v1vl");

var $8ght1 = parcelRequire("8ght1");

var $LBO4U = parcelRequire("LBO4U");

var $d85fI = parcelRequire("d85fI");

var $dAkPh = parcelRequire("dAkPh");
let $951136ac6521859b$export$a77041a9872c5f6 = (()=>{
    let _classDecorators = [
        (0, $8ght1.Injectable)({
            implements: (0, $LBO4U.$Database)
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var ArcaeaToolbeltDatabaseContext = class {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            (0, $2v1vl.__esDecorate)(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            ArcaeaToolbeltDatabaseContext = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            (0, $2v1vl.__runInitializers)(_classThis, _classExtraInitializers);
        }
        caches = "caches";
        preference = "preference";
        profiles = "profiles";
        core = "core";
        files = "files";
        getDB = (0, $dAkPh.once)(()=>this.#create());
        async transaction(stores, mode) {
            const db = await this.getDB();
            return db.transaction(stores, mode);
        }
        async objectStore(store, mode) {
            const transaction = await this.transaction([
                store
            ], mode);
            return transaction.objectStore(store);
        }
        #create() {
            const manager = new (0, $d85fI.DBVersionManager)().version(1, (db)=>{
                db.createObjectStore(this.caches, {
                    keyPath: "url"
                });
                db.createObjectStore(this.preference, {
                    keyPath: "key"
                });
                db.createObjectStore(this.profiles, {
                    keyPath: "username"
                });
            }).version(2, (db)=>{
                db.createObjectStore(this.core, {
                    keyPath: "path"
                });
            }).version(3, (db)=>{
                db.createObjectStore(this.files, {
                    keyPath: "url"
                });
            });
            return manager.open("arcaea-toolbelt", 3);
        }
    };
    return ArcaeaToolbeltDatabaseContext = _classThis;
})();

});

parcelRegister("4VkmJ", function(module, exports) {

$parcel$export(module.exports, "DirectGateway", () => $395c487b096ee05f$export$948fed883ad4d4a);
$parcel$export(module.exports, "ProxyGateway", () => $395c487b096ee05f$export$c5e7150b800f5c0f);

var $2v1vl = parcelRequire("2v1vl");

var $8ght1 = parcelRequire("8ght1");

var $baotA = parcelRequire("baotA");

var $LBO4U = parcelRequire("LBO4U");

var $guLfS = parcelRequire("guLfS");
const $395c487b096ee05f$var$assetsBase = "https://moezako.github.io/zakozip/arcaea/assets/";
const $395c487b096ee05f$var$assetsProxyBase = "https://moezako.github.io/zakozip/arcaea/assets/";
const $395c487b096ee05f$var$dataProxyBase = "https://mirror.ghproxy.com/raw.githubusercontent.com/DarrenDanielDay/arcaea-toolbelt-data/main/src/data/";
const $395c487b096ee05f$var$directGateway = {
    "//assets/": $395c487b096ee05f$var$assetsBase,
    "//data/": "/arcaea-toolbelt-data/"
};
const $395c487b096ee05f$var$proxyGateway = {
    "//assets/": $395c487b096ee05f$var$assetsProxyBase,
    "//data/": $395c487b096ee05f$var$dataProxyBase
};
let $395c487b096ee05f$export$948fed883ad4d4a = (()=>{
    let _classDecorators = [
        (0, $8ght1.Injectable)({
            implements: (0, $LBO4U.$Gateway)
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var DirectGateway = class {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            (0, $2v1vl.__esDecorate)(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            DirectGateway = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            (0, $2v1vl.__runInitializers)(_classThis, _classExtraInitializers);
        }
        direct(url) {
            return this.map(url, $395c487b096ee05f$var$directGateway);
        }
        proxy(url) {
            return this.map(url, $395c487b096ee05f$var$proxyGateway);
        }
        dynamicProxy(url) {
            return this.map(url, $395c487b096ee05f$var$directGateway);
        }
        map(url, mapping) {
            if (url.protocol === (0, $baotA.protocol)) return this.proxyCustomProtocol(url, mapping);
            return url;
        }
        proxyCustomProtocol(url, mapping) {
            const pathname = url.toString().slice((0, $baotA.protocol).length);
            const pair = Object.entries(mapping).find(([key])=>pathname.startsWith(key));
            if (pair) {
                const [prefix, base] = pair;
                const baseURL = base.startsWith("/") ? new URL(base, "https://darrendanielday.github.io/arcaea-toolbelt/") : base;
                return new URL(pathname.slice(prefix.length), baseURL);
            }
            throw new Error(`Unknown path: ${pathname}`);
        }
    };
    return DirectGateway = _classThis;
})();
let $395c487b096ee05f$export$c5e7150b800f5c0f = (()=>{
    let _classDecorators = [
        (0, $8ght1.Injectable)({
            implements: (0, $LBO4U.$Gateway),
            requires: [
                (0, $LBO4U.$PreferenceService)
            ]
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = $395c487b096ee05f$export$948fed883ad4d4a;
    var ProxyGateway = class extends _classSuper {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            (0, $2v1vl.__esDecorate)(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            ProxyGateway = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            (0, $2v1vl.__runInitializers)(_classThis, _classExtraInitializers);
        }
        preference;
        ghproxy = false;
        constructor(preference){
            super();
            this.preference = preference;
            (0, $guLfS.subscribe)(preference.signal("ghproxy"), (value)=>{
                this.ghproxy = value;
            });
        }
        proxy(url) {
            return this.map(url, this.ghproxy ? $395c487b096ee05f$var$proxyGateway : $395c487b096ee05f$var$directGateway);
        }
        async dynamicProxy(url) {
            const { ghproxy: ghproxy } = await this.preference.get();
            this.ghproxy = ghproxy;
            return this.proxy(url);
        }
    };
    return ProxyGateway = _classThis;
})();

});

parcelRegister("dKfjq", function(module, exports) {

$parcel$export(module.exports, "MemoryCache", () => $a01b72f0e88e19f9$export$67418a4e428ce890);
class $a01b72f0e88e19f9$export$67418a4e428ce890 {
    provider;
    #cache = new Map();
    #pending = new Map();
    constructor(provider){
        this.provider = provider;
    }
    async get(...args) {
        const cache = this.#cache;
        const key = this.provider.key(...args);
        const cached = cache.get(key);
        if (cached) return cached;
        let pending = this.#pending.get(key);
        if (pending != null) return this.complete(pending, args, key);
        try {
            pending = this.provider.alloc(...args);
            this.#pending.set(key, pending);
            const data = await pending;
            return this.complete(data, args, key);
        } finally{
            this.#pending.delete(key);
        }
    }
    async delete(...args) {
        const cache = this.#cache;
        const key = this.provider.key(...args);
        const cached = cache.get(key);
        if (cached) {
            await this.provider.free?.(cached);
            cache.delete(key);
        }
    }
    async clear() {
        const cache = this.#cache;
        for (const key of [
            ...cache.keys()
        ]){
            const cached = cache.get(key);
            await this.provider.free?.(cached);
            cache.delete(key);
        }
    }
    async complete(promise, args, key) {
        const data = await promise;
        this.#cache.set(key, data);
        return this.provider.clone?.(data, args) ?? data;
    }
}

});

parcelRegister("6sgD2", function(module, exports) {

$parcel$export(module.exports, "CoreDataServiceImpl", () => $4b3241b4188458c6$export$a0fabe89a3542d65);

var $2v1vl = parcelRequire("2v1vl");

var $8ght1 = parcelRequire("8ght1");

var $LBO4U = parcelRequire("LBO4U");

var $lRH1D = parcelRequire("lRH1D");
let $4b3241b4188458c6$export$a0fabe89a3542d65 = (()=>{
    let _classDecorators = [
        (0, $8ght1.Injectable)({
            requires: [
                (0, $LBO4U.$CoreDataProvider)
            ],
            implements: (0, $LBO4U.$CoreDataService)
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var CoreDataServiceImpl = class {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            (0, $2v1vl.__esDecorate)(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            CoreDataServiceImpl = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            (0, $2v1vl.__runInitializers)(_classThis, _classExtraInitializers);
        }
        provider;
        constructor(provider){
            this.provider = provider;
        }
        fetch(path) {
            return this.provider.get(path);
        }
        getAssetsInfo() {
            return this.fetch((0, $lRH1D.assetsInfo));
        }
        getSongList() {
            return this.fetch((0, $lRH1D.songList));
        }
        getPackList() {
            return this.fetch((0, $lRH1D.packList));
        }
        getMetaData() {
            return this.fetch((0, $lRH1D.meta));
        }
        getChartExpress() {
            return this.fetch((0, $lRH1D.chartExpress));
        }
        getChartData() {
            return this.fetch((0, $lRH1D.chartData));
        }
        getCharacterData() {
            return this.fetch((0, $lRH1D.characterData));
        }
        getItemsData() {
            return this.fetch((0, $lRH1D.items));
        }
        getWorldMapLongTerm() {
            return this.fetch((0, $lRH1D.worldMapsLongterm));
        }
        getWorldMapEvents() {
            return this.fetch((0, $lRH1D.worldMapsEvents));
        }
    };
    return CoreDataServiceImpl = _classThis;
})();

});
parcelRegister("lRH1D", function(module, exports) {

$parcel$export(module.exports, "assetsInfo", () => $feafec26cced6554$export$35d7e00025bec609);
$parcel$export(module.exports, "characterData", () => $feafec26cced6554$export$b99ebf535cc5b07);
$parcel$export(module.exports, "chartData", () => $feafec26cced6554$export$fa75311891f179ce);
$parcel$export(module.exports, "chartExpress", () => $feafec26cced6554$export$ef8ee5f005c3a4cd);
$parcel$export(module.exports, "items", () => $feafec26cced6554$export$17a1664ed1fb5d6f);
$parcel$export(module.exports, "meta", () => $feafec26cced6554$export$6990040ee07315);
$parcel$export(module.exports, "packList", () => $feafec26cced6554$export$4a70916ed1961946);
$parcel$export(module.exports, "songList", () => $feafec26cced6554$export$e8cfc57a0a2cf653);
$parcel$export(module.exports, "worldMapsEvents", () => $feafec26cced6554$export$d8cb020fe65fe8d2);
$parcel$export(module.exports, "worldMapsLongterm", () => $feafec26cced6554$export$ae47ed3dfcfcb217);
const $feafec26cced6554$export$8de3e08801b34e5a = "alias.json";
const $feafec26cced6554$export$35d7e00025bec609 = "assets-info.json";
const $feafec26cced6554$export$b99ebf535cc5b07 = "character-data.json";
const $feafec26cced6554$export$30a86d91af8ff6e6 = "characters.json";
const $feafec26cced6554$export$fa75311891f179ce = "chart-data.json";
const $feafec26cced6554$export$ef8ee5f005c3a4cd = "chart-express.json";
const $feafec26cced6554$export$81a07726944e47e0 = "item-data.json";
const $feafec26cced6554$export$17a1664ed1fb5d6f = "items.json";
const $feafec26cced6554$export$6990040ee07315 = "meta.json";
const $feafec26cced6554$export$76f21a9c4db68ed = "notes-and-constants.json";
const $feafec26cced6554$export$4a70916ed1961946 = "packlist.json";
const $feafec26cced6554$export$e8cfc57a0a2cf653 = "songlist.json";
const $feafec26cced6554$export$d8cb020fe65fe8d2 = "world-maps-events.json";
const $feafec26cced6554$export$ae47ed3dfcfcb217 = "world-maps-longterm.json";

});


parcelRegister("608mA", function(module, exports) {

$parcel$export(module.exports, "CoreDataProviderImpl", () => $45e93af6fa592764$export$d11ce8ee2e11aa7b);

var $2v1vl = parcelRequire("2v1vl");

var $8ght1 = parcelRequire("8ght1");

var $LBO4U = parcelRequire("LBO4U");

var $dKfjq = parcelRequire("dKfjq");

var $baotA = parcelRequire("baotA");

var $lRH1D = parcelRequire("lRH1D");

var $d85fI = parcelRequire("d85fI");
let $45e93af6fa592764$export$d11ce8ee2e11aa7b = (()=>{
    let _classDecorators = [
        (0, $8ght1.Injectable)({
            requires: [
                (0, $LBO4U.$Database),
                (0, $LBO4U.$Gateway)
            ],
            implements: (0, $LBO4U.$CoreDataProvider)
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var CoreDataProviderImpl = class {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            (0, $2v1vl.__esDecorate)(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            CoreDataProviderImpl = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            (0, $2v1vl.__runInitializers)(_classThis, _classExtraInitializers);
        }
        database;
        gateway;
        #memoryCache = new (0, $dKfjq.MemoryCache)(this);
        #metaCache = new (0, $dKfjq.MemoryCache)({
            key: ()=>"meta",
            alloc: async ()=>await this.fetchJSON((0, $baotA.toolbelt).data((0, $lRH1D.meta)))
        });
        constructor(database, gateway){
            this.database = database;
            this.gateway = gateway;
        }
        key(path) {
            return path;
        }
        async alloc(path) {
            const meta = await this.getMeta();
            const item = meta.index.find((item)=>item.file === path);
            if (!item) throw new Error(`Cannot resolve data file ${path}.`);
            let store = await this.database.objectStore(this.database.core, "readwrite");
            const cache = await (0, $d85fI.requestToPromise)(store.get(path));
            if (cache?.hash === item.hash) return cache.content;
            const fetched = await this.fetchJSON((0, $baotA.toolbelt).data(path));
            // check hash?
            const newData = {
                hash: item.hash,
                path: path,
                content: fetched
            };
            store = await this.database.objectStore(this.database.core, "readwrite");
            await (0, $d85fI.requestToPromise)(store.put(newData));
            return fetched;
        }
        async get(path) {
            if (path === (0, $lRH1D.meta)) return await this.getMeta();
            return this.#memoryCache.get(path);
        }
        async getMeta() {
            return this.#metaCache.get();
        }
        async fetchJSON(url) {
            const response = await this.tryFetch(url);
            return response.json();
        }
        async tryFetch(url) {
            try {
                const dist = await this.gateway.dynamicProxy(url);
                const response = await fetch(dist);
                if (!response.ok) throw new Error(`Failed to request proxy ${dist}`);
                return response;
            } catch (error) {
                console.error(error);
                return await fetch(this.gateway.direct(url));
            }
        }
    };
    return CoreDataProviderImpl = _classThis;
})();

});

parcelRegister("8CQ5S", function(module, exports) {

$parcel$export(module.exports, "StorageLogger", () => $647a480fc0918f57$export$8e142880997144ce);

var $2v1vl = parcelRequire("2v1vl");

var $8ght1 = parcelRequire("8ght1");

var $LBO4U = parcelRequire("LBO4U");

var $dAkPh = parcelRequire("dAkPh");
const $647a480fc0918f57$export$ac4ff9298339bd11 = (0, $dAkPh.shape)({
    content: (0, $dAkPh.nocheck),
    level: (0, $dAkPh.isNumber),
    stack: (0, $dAkPh.isString),
    timestamp: (0, $dAkPh.isNumber)
});
let $647a480fc0918f57$export$8e142880997144ce = (()=>{
    var _a, _StorageLogger_key, _StorageLogger_notrace, _StorageLogger_maxLogCount;
    let _classDecorators = [
        (0, $8ght1.Injectable)({
            implements: (0, $LBO4U.$Logger),
            requires: [
                (0, $LBO4U.$LowLevelStorage)
            ]
        })
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var StorageLogger = _a = class {
        static{
            _classThis = this;
        }
        static{
            (0, $2v1vl.__setFunctionName)(this, "StorageLogger");
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            (0, $2v1vl.__esDecorate)(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            StorageLogger = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        }
        storage;
        static{
            // 申请中译中.txt
            _StorageLogger_key = {
                value: "	--\u3010<!--#\u65E5\u8A8C-->\u3011--"
            };
        }
        static{
            _StorageLogger_notrace = {
                value: "<no stack trace>"
            };
        }
        static{
            _StorageLogger_maxLogCount = {
                value: 1024
            };
        }
        debug = this.#logFuncFactory((0, $LBO4U.LogLevel).Debug);
        info = this.#logFuncFactory((0, $LBO4U.LogLevel).Info);
        warn = this.#logFuncFactory((0, $LBO4U.LogLevel).Warning);
        error = this.#logFuncFactory((0, $LBO4U.LogLevel).Error);
        fatal = this.#logFuncFactory((0, $LBO4U.LogLevel).Fatal);
        constructor(storage){
            this.storage = storage;
        }
        async getHistory() {
            return this.#readFromStore();
        }
        async clear() {
            this.storage.removeItem((0, $2v1vl.__classPrivateFieldGet)(StorageLogger, _classThis, "f", _StorageLogger_key));
        }
        #logFuncFactory(level) {
            const func = (...args)=>{
                const { stack: stack = (0, $2v1vl.__classPrivateFieldGet)(StorageLogger, _classThis, "f", _StorageLogger_notrace) } = new Error("Stack");
                const log = {
                    content: args,
                    level: level,
                    stack: stack,
                    timestamp: Date.now()
                };
                this.#addLog(log);
            };
            func.trace = (tag, value)=>{
                const { stack: stack = (0, $2v1vl.__classPrivateFieldGet)(StorageLogger, _classThis, "f", _StorageLogger_notrace) } = new Error("Stack");
                const log = {
                    content: [
                        tag,
                        value
                    ],
                    level: level,
                    stack: stack,
                    timestamp: Date.now()
                };
                this.#addLog(log);
                return value;
            };
            return func;
        }
        #readFromStore() {
            const text = this.storage.getItem((0, $2v1vl.__classPrivateFieldGet)(StorageLogger, _classThis, "f", _StorageLogger_key));
            if (text == null) return [];
            return this.#deserialize(text);
        }
        #deserialize(text) {
            try {
                const parsed = JSON.parse(text);
                if (!Array.isArray(parsed)) return [];
                return parsed.filter($647a480fc0918f57$export$ac4ff9298339bd11).sort((a, b)=>a.timestamp - b.timestamp);
            } catch (error) {
                console.error(error);
                return [];
            }
        }
        #addLog(log) {
            const logs = this.#readFromStore();
            logs.push(log);
            if (logs.length >= (0, $2v1vl.__classPrivateFieldGet)(StorageLogger, _classThis, "f", _StorageLogger_maxLogCount)) logs.shift();
            this.#saveToStore(logs);
        }
        #saveToStore(logs) {
            this.storage.setItem((0, $2v1vl.__classPrivateFieldGet)(StorageLogger, _classThis, "f", _StorageLogger_key), this.#serialize(logs));
        }
        #serialize(logs) {
            return JSON.stringify(logs);
        }
        static{
            (0, $2v1vl.__runInitializers)(_classThis, _classExtraInitializers);
        }
    };
    return StorageLogger = _classThis;
})();

});

var $27eb645ca0ab5ca3$exports = {};
$parcel$extendImportMap({
    "j2oJf": "sql-wasm-browser.0e3ea084.js",
    "8CZrQ": "sql-wasm.b3401514.wasm",
    "aK2K0": "chart-data-legacy-1.8b31ffbd.js"
});


//# sourceMappingURL=arcaea-toolbelt.5bb2f127.js.map
